var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { reactive, ref, computed, provide, onMounted, inject, getCurrentInstance, defineComponent, defineAsyncComponent, onUpdated, openBlock, createElementBlock, unref, createBlock, resolveDynamicComponent, mergeProps, withModifiers, createVNode, useCssVars, normalizeClass, normalizeStyle, createCommentVNode, createElementVNode, Transition, withCtx, withDirectives, Fragment, renderList, vShow, watch, createTextVNode, toDisplayString, renderSlot, watchEffect, onBeforeUnmount, toRaw } from "vue";
import { ToolActionKind, DefaultStep, RadiusKind, MeasureUnit, ToolPosition, FontType, TextTransform, ButtonStyleKind, ToolKind, Locale, DeviceKind, activityKindLiteralMap, perkTooltipKindLiteralMap, LocaleImageKind, CountdownKind, CountdownTimezone, ToolModuleKind, ButtonActionKind, ToolLayoutKind, TermsLinkKind, PerkLayoutKind, FormFieldsPosition, FormSelectionKind, FormFieldKind } from "@thehotelsnetwork/personalization-types";
import tinycolor from "tinycolor2";
import { useElementSize, useSwipe, watchOnce, useEventListener } from "@vueuse/core";
import { CrossIcon, ArrowUpRightIcon, NotificationInfoIcon } from "@thehotelsnetwork/icons/vue/linear";
const __variableDynamicImportRuntimeHelper$ = (glob, path) => {
  const v = glob[path];
  if (v) {
    return typeof v === "function" ? v() : Promise.resolve(v);
  }
  return new Promise((_, reject) => {
    (typeof queueMicrotask === "function" ? queueMicrotask : setTimeout)(reject.bind(null, new Error("Unknown variable dynamic import: " + path)));
  });
};
var ButtonState = /* @__PURE__ */ ((ButtonState2) => {
  ButtonState2["Active"] = "active";
  ButtonState2["Sending"] = "sending";
  ButtonState2["Success"] = "success";
  ButtonState2["Failure"] = "failure";
  return ButtonState2;
})(ButtonState || {});
const requireFeedbackStepActions = [
  ToolActionKind.SendForm,
  ToolActionKind.SendSaveSearch,
  ToolActionKind.SendSubscribe
];
const requireHideToolActions = [
  ToolActionKind.ApplyDiscount,
  ToolActionKind.OpenUri,
  ToolActionKind.OpenBookingEngine,
  ToolActionKind.EmptyClick,
  ToolActionKind.Dismiss
];
const closingToolActions = [
  ToolActionKind.Hide
];
class HandlersStore {
  constructor() {
    __publicField(this, "dataValidators", {});
    __publicField(this, "state", reactive({
      actions: [],
      buttonState: ButtonState.Active,
      stepActive: DefaultStep.Main,
      stepPrevious: null,
      isFirstStep: true,
      hideFunction: () => {
      }
    }));
  }
  get buttonState() {
    return this.state.buttonState;
  }
  get isFirstStep() {
    return this.state.isFirstStep;
  }
  get stepActive() {
    return this.state.stepActive;
  }
  get stepPrevious() {
    return this.state.stepPrevious;
  }
  initialize(hideFunction, actions) {
    this.state.hideFunction = hideFunction;
    this.state.actions = actions;
  }
  setDataValidator(kind, validateFunction) {
    this.dataValidators[kind] = validateFunction;
  }
  async callHandler(kind, moduleId) {
    if (!this.state.actions)
      return;
    let handlerData = {};
    const dataValidator = this.dataValidators[kind];
    if (dataValidator) {
      handlerData = await dataValidator();
      if (!handlerData) {
        return;
      }
    }
    let handlerAction;
    const findCallbackFn = [
      (action) => action.kind === kind,
      (action) => action.kind === ToolActionKind.Fallback
    ];
    if (moduleId) {
      findCallbackFn.unshift((action) => action.moduleId === moduleId);
    }
    for (let i = 0; !handlerAction && i < findCallbackFn.length; i += 1) {
      handlerAction = this.state.actions.find(findCallbackFn[i]);
    }
    if (!handlerAction)
      return;
    let response = false;
    if (handlerAction.handler) {
      this.state.buttonState = ButtonState.Sending;
      response = await handlerAction.handler(handlerData);
      this.state.buttonState = ButtonState.Active;
    }
    if (requireFeedbackStepActions.includes(kind)) {
      this.state.stepActive = response ? DefaultStep.Success : DefaultStep.Failure;
      this.state.isFirstStep = false;
    }
    if (requireHideToolActions.includes(kind)) {
      this.callHandler(ToolActionKind.Hide);
    }
    if (closingToolActions.includes(kind)) {
      this.state.hideFunction();
    }
  }
  goBackToMainStep() {
    this.state.stepPrevious = this.state.stepActive;
    this.state.stepActive = DefaultStep.Main;
    this.state.isFirstStep = true;
  }
  reset() {
    this.state.buttonState = ButtonState.Active;
    this.state.stepActive = DefaultStep.Main;
    this.state.isFirstStep = true;
  }
}
function hexToRgba(hexStr, alpha = 1) {
  let hex = hexStr.replace("#", "");
  if (![3, 6].includes(hex.length)) {
    return null;
  }
  if (hex.length === 3) {
    hex = hex.split("").map((hexChar) => hexChar + hexChar).join("");
  }
  const c = parseInt(hex, 16);
  return `rgba(${c >> 16 & 255},${c >> 8 & 255},${c & 255},${alpha})`;
}
function toPascalCase(str) {
  const tempStr = str.replace(/[-_\s]+(.)?/g, (_match, ch) => ch ? ch.toUpperCase() : "");
  return tempStr.substring(0, 1).toUpperCase() + tempStr.substring(1);
}
function toKebabCase(str) {
  return str.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
}
const camelToSnakeCase = (str) => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
function getCornerRadius(refKind) {
  const kind = (refKind == null ? void 0 : refKind.kind) || RadiusKind.Rounded;
  switch (kind) {
    case RadiusKind.Custom:
      const customKind = refKind;
      return `${customKind.value}${customKind.format}`;
    case RadiusKind.Square:
      return "0px";
    case RadiusKind.Medium:
      return "6px";
    case RadiusKind.Rounded:
    default:
      return "16px";
  }
}
function appendPx(num = 0) {
  return `${num}px`;
}
function appendPercent(num = 0) {
  return `${num}%`;
}
function appendEm(num = 0) {
  return `${num}em`;
}
function getEmByPercent(percent) {
  return `${percent * 6 / 100}em`;
}
function getPaddingLiteral({
  format,
  top,
  right,
  bottom,
  left
}) {
  switch (format) {
    case MeasureUnit.Pixels:
      return `${top}${format} ${right}${format} ${bottom}${format} ${left}${format}`;
    case MeasureUnit.Em:
    default:
      return `${getEmByPercent(top)} ${getEmByPercent(right)} ${getEmByPercent(bottom)} ${getEmByPercent(left)}`;
  }
}
function isObj(object) {
  return (object == null ? void 0 : object.constructor) === Object;
}
function padNumber(num, maxLength = 2) {
  return num.toFixed(0).padStart(maxLength, "0");
}
const buttonActionTypesMap = {
  apply_promo_code: ToolActionKind.ApplyDiscount,
  close_tool: ToolActionKind.EmptyClick,
  emailCapture: ToolActionKind.SendSubscribe,
  form: ToolActionKind.SendForm,
  open_url: ToolActionKind.OpenUri,
  call_phone_number: ToolActionKind.OpenUri,
  open_mail_client: ToolActionKind.OpenUri,
  savedSearch: ToolActionKind.SendSaveSearch,
  send_to_be: ToolActionKind.OpenBookingEngine
};
function getButtonActionType(type) {
  return buttonActionTypesMap[type];
}
function getTransitionName(baseName, position = ToolPosition.UpperLeft) {
  let transition = baseName;
  switch (position) {
    case ToolPosition.Top:
      transition += "-from-top";
      break;
    case ToolPosition.Bottom:
      transition += "-from-bottom";
      break;
    default:
      transition += `-from-${position.slice(-1) === "L" ? "left" : "right"}`;
      break;
  }
  return transition;
}
var objectProto$6 = Object.prototype;
function isPrototype(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$6;
  return value === proto;
}
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var nativeKeys = overArg(Object.keys, Object);
const nativeKeys$1 = nativeKeys;
var objectProto$5 = Object.prototype;
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys$1(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$4.call(object, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
const freeGlobal$1 = freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal$1 || freeSelf || Function("return this")();
const root$1 = root;
var Symbol$1 = root$1.Symbol;
const Symbol$2 = Symbol$1;
var objectProto$4 = Object.prototype;
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
var nativeObjectToString$1 = objectProto$4.toString;
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty$3.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var objectProto$3 = Object.prototype;
var nativeObjectToString = objectProto$3.toString;
function objectToString(value) {
  return nativeObjectToString.call(value);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
function isObject(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var coreJsData = root$1["__core-js_shared__"];
const coreJsData$1 = coreJsData;
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {
    }
    try {
      return func + "";
    } catch (e) {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype, objectProto$2 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
function getValue(object, key) {
  return object == null ? void 0 : object[key];
}
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}
var DataView = getNative(root$1, "DataView");
const DataView$1 = DataView;
var Map = getNative(root$1, "Map");
const Map$1 = Map;
var Promise$1 = getNative(root$1, "Promise");
const Promise$2 = Promise$1;
var Set = getNative(root$1, "Set");
const Set$1 = Set;
var WeakMap = getNative(root$1, "WeakMap");
const WeakMap$1 = WeakMap;
var mapTag$2 = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag$2 = "[object Set]", weakMapTag$1 = "[object WeakMap]";
var dataViewTag$1 = "[object DataView]";
var dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$2), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1);
var getTag = baseGetTag;
if (DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$1 || Map$1 && getTag(new Map$1()) != mapTag$2 || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$1 && getTag(new Set$1()) != setTag$2 || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag$1) {
  getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$1 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$1;
        case mapCtorString:
          return mapTag$2;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$2;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result;
  };
}
const getTag$1 = getTag;
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var argsTag$1 = "[object Arguments]";
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$1;
}
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
var propertyIsEnumerable = objectProto$1.propertyIsEnumerable;
var isArguments = baseIsArguments(function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$1.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
const isArguments$1 = isArguments;
var isArray = Array.isArray;
const isArray$1 = isArray;
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}
function stubFalse() {
  return false;
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var Buffer2 = moduleExports$1 ? root$1.Buffer : void 0;
var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
var isBuffer = nativeIsBuffer || stubFalse;
const isBuffer$1 = isBuffer;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag$1 = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var freeProcess = moduleExports && freeGlobal$1.process;
var nodeUtil = function() {
  try {
    var types = freeModule && freeModule.require && freeModule.require("util").types;
    if (types) {
      return types;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (e) {
  }
}();
const nodeUtil$1 = nodeUtil;
var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
const isTypedArray$1 = isTypedArray;
var mapTag = "[object Map]", setTag = "[object Set]";
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) && (isArray$1(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer$1(value) || isTypedArray$1(value) || isArguments$1(value))) {
    return !value.length;
  }
  var tag = getTag$1(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}
const noteDefaultColorsStyles = {
  paragraph: "#000000",
  buttonText: "#ffffff",
  link: "#1C8BF1",
  buttonBackground: "#000000",
  background: {
    base: "#ffffff"
  },
  icon: "#000000",
  countdown: "#F2F2F2",
  countdownText: "#000000",
  countdownNumber: "#000000"
};
const defaultColorStyles = {
  heading: "#000000",
  paragraph: "#000000",
  link: "#1C8BF1",
  buttonText: "#FFFFFF",
  buttonBackground: "#000000",
  background: {
    base: "#FFFFFF"
  },
  icon: "#000000",
  perks: "#000000",
  countdown: "#F2F2F2",
  countdownText: "#000000",
  countdownNumber: "#000000"
};
const defaultFontsStyles = {
  heading: {
    spec: {
      key: "Playfair+Display",
      name: "Playfair Display",
      cssName: "Playfair Display",
      type: "serif",
      fontType: FontType.Google,
      source: ""
    },
    style: "bold",
    textTransform: TextTransform.None
  },
  paragraph: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: FontType.Google,
      source: ""
    },
    style: "regular",
    textTransform: TextTransform.None
  },
  formFieldName: {
    spec: {
      key: "Source+Sans+Pro",
      name: "Source Sans Pro",
      cssName: "Source Sans Pro",
      type: "sans-serif",
      fontType: FontType.Google,
      source: ""
    },
    style: "regular",
    textTransform: TextTransform.None
  },
  other: {
    spec: {
      key: "Source+Sans+Pro",
      name: "Source Sans Pro",
      cssName: "Source Sans Pro",
      type: "sans-serif",
      fontType: FontType.Google,
      source: ""
    },
    style: "regular",
    textTransform: TextTransform.None
  },
  button: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: FontType.Google,
      source: ""
    },
    style: "regular",
    textTransform: TextTransform.None
  }
};
const defaultButtonStyles = {
  note: {
    style: ButtonStyleKind.Solid,
    cornerRadius: {
      kind: RadiusKind.Medium
    },
    padding: {
      top: 8,
      right: 16,
      bottom: 8,
      left: 16,
      format: MeasureUnit.Em
    }
  },
  layer: {
    style: ButtonStyleKind.Solid,
    cornerRadius: {
      kind: RadiusKind.Medium
    },
    padding: {
      top: 14,
      right: 22,
      bottom: 14,
      left: 22,
      format: MeasureUnit.Em
    }
  },
  exit: {
    style: ButtonStyleKind.Solid,
    cornerRadius: {
      kind: RadiusKind.Medium
    },
    padding: {
      top: 14,
      right: 22,
      bottom: 14,
      left: 22,
      format: MeasureUnit.Em
    }
  },
  inliner: {
    style: ButtonStyleKind.Solid,
    cornerRadius: {
      kind: RadiusKind.Medium
    },
    padding: {
      top: 14,
      right: 22,
      bottom: 14,
      left: 22,
      format: MeasureUnit.Em
    }
  }
};
const defaultBackgroundStyles = {
  opacity: 100,
  cornerRadius: {
    kind: RadiusKind.Medium
  }
};
const defaultInlinerBackgroundStyles = {
  opacity: 100,
  cornerRadius: {
    kind: RadiusKind.Medium
  },
  border: {
    color: "#D9D9D9",
    thickness: 1
  }
};
const defaultOverlayStyles = {
  color: "#000000",
  opacity: 50
};
function useDefaultStyles(type) {
  const toolType = ref(type);
  const defaultButtonStylesByTool = computed(
    () => defaultButtonStyles[toolType.value] || defaultButtonStyles.layer
  );
  return reactive({
    colors: { ...defaultColorStyles },
    fonts: { ...defaultFontsStyles },
    button: { ...defaultButtonStylesByTool.value },
    background: toolType.value === "inliner" ? { ...defaultInlinerBackgroundStyles } : { ...defaultBackgroundStyles },
    overlay: { ...defaultOverlayStyles }
  });
}
function parseToolData({
  tool,
  context,
  toolKind
}) {
  let layout;
  let position;
  let tokens;
  let embedded;
  const {
    builderMode,
    defaultAssets,
    deviceViewport,
    firstVisitDate,
    actions,
    hotelTimezone,
    hotelTimezoneOffset,
    language,
    countdownTimestamp
  } = context;
  if (isEmpty(tool.theme.styles) || !tool.theme.styles) {
    tool.theme.styles = useDefaultStyles(toolKind);
  }
  const {
    content: {
      modules
    },
    settings: {
      devices
    },
    theme: {
      styles
    }
  } = tool;
  if (toolKind !== ToolKind.Note) {
    layout = tool.settings.layout;
  } else {
    tokens = tool.tokens;
  }
  if (toolKind === ToolKind.Inliner) {
    embedded = tool.settings.embedded;
  }
  if (devices) {
    position = devices[deviceViewport].position;
  }
  const extraData = {
    builderMode,
    firstVisitDate,
    hotelTimezone,
    hotelTimezoneOffset,
    defaultAssets,
    countdownTimestamp,
    tokens
  };
  return {
    language,
    device: deviceViewport,
    position,
    modules,
    layout,
    styles,
    actions,
    extraData,
    embedded
  };
}
function toTitleCase(text) {
  const smallWords = /^(&|&amp;|a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|v.?|vs.?|via)$/i;
  const alphanumericPattern = /([A-Za-z0-9\u00C0-\u00FF])/;
  const wordSeparators = /([ :–—-])/;
  return text.split(wordSeparators).map((current, index, array) => {
    if (current.search(smallWords) > -1 && index !== 0 && index !== array.length - 1 && array[index - 3] !== ":" && array[index + 1] !== ":" && (array[index + 1] !== "-" || array[index - 1] === "-" && array[index + 1] === "-")) {
      return current.toLowerCase();
    }
    if (current.substring(1).search(/[A-Z]|\../) > -1) {
      return current;
    }
    if (array[index + 1] === ":" && array[index + 2] !== "") {
      return current;
    }
    return current.replace(alphanumericPattern, (match) => match.toUpperCase());
  }).join("");
}
function assignFormatFunction(unit) {
  return unit === "px" ? appendPx : appendPercent;
}
function calcMarginByDevice(device) {
  const {
    format,
    top,
    right,
    bottom,
    left
  } = device.margin;
  const formatter = assignFormatFunction(format);
  return `${formatter(top)} ${formatter(right)} ${formatter(bottom)} ${formatter(left)}`;
}
function calcWidthByDevice(device) {
  const { width, widthFormat } = device;
  const formatter = assignFormatFunction(widthFormat);
  return `${formatter(width)}`;
}
function calcPlacementByDevice(device) {
  const placement = {
    left: "start",
    center: "center",
    right: "end"
  };
  return placement[device.alignment];
}
function colorHelper(input) {
  const color = tinycolor(input);
  const isDark = () => color.getLuminance() <= 0.5;
  const darken = (amount) => color.darken(amount).toString();
  const lighten = (amount) => color.lighten(amount).toString();
  const setAlpha = (amount) => color.setAlpha(amount).toString();
  return {
    isDark,
    darken,
    lighten,
    setAlpha
  };
}
function parseCssValue(key, value) {
  switch (key) {
    case "opacity":
      return (parseInt(value, 10) / 100).toString();
    case "thickness":
      return appendPx(parseInt(value, 10));
    case "cssName":
      return `'${value}'`;
    default:
      return value;
  }
}
function parseCssObjectValue(key, value) {
  switch (key) {
    case "cornerRadius":
      return getCornerRadius(value);
    case "padding":
      return getPaddingLiteral(value);
    default:
      return null;
  }
}
function getCssVarNames(styles, prefix) {
  return Object.keys(styles).reduce((stylesObj, key) => {
    var _a;
    let value = parseCssValue(key, (_a = styles[key]) == null ? void 0 : _a.toString());
    if (isObj(styles[key])) {
      value = parseCssObjectValue(key, styles[key]);
      if (!value) {
        const newObj = {
          ...stylesObj,
          ...getCssVarNames(styles[key], `${prefix}-${key}`)
        };
        return newObj;
      }
    }
    stylesObj[`${prefix}-${toKebabCase(key)}`] = value;
    return stylesObj;
  }, {});
}
class StylesStore {
  constructor() {
    __publicField(this, "rootDom", null);
    __publicField(this, "state", reactive({
      colors: {},
      fonts: {},
      button: {},
      background: {},
      overlay: {}
    }));
  }
  get rootElement() {
    return this.rootDom;
  }
  get fonts() {
    return this.state.fonts;
  }
  get backgroundImage() {
    var _a, _b;
    return (_b = (_a = this.state.background.image) == null ? void 0 : _a.urls) == null ? void 0 : _b.edited;
  }
  get backgroundImageAlt() {
    var _a;
    return (_a = this.state.background.image) == null ? void 0 : _a.alt;
  }
  get colors() {
    return this.state.colors;
  }
  get button() {
    return this.state.button;
  }
  initialize(styles, rootDom) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
    this.rootDom = rootDom;
    this.state.colors = styles.colors || {};
    this.state.fonts = styles.fonts || {};
    this.state.button = styles.button || {};
    this.state.background = styles.background || {};
    this.state.overlay = styles.overlay || {};
    const cssVars = getCssVarNames(this.state, "--thn-tool");
    this.addCssVariables({
      ...cssVars,
      "--thn-tool-colors-icon-back": hexToRgba(((_a = styles.colors) == null ? void 0 : _a.icon) || "#000000", 0.15),
      "--thn-tool-colors-background": ((_c = (_b = styles.colors) == null ? void 0 : _b.background) == null ? void 0 : _c.gradient) ? `linear-gradient(to right bottom, ${(_e = (_d = styles.colors) == null ? void 0 : _d.background) == null ? void 0 : _e.base}, ${(_g = (_f = styles.colors) == null ? void 0 : _f.background) == null ? void 0 : _g.gradient})` : (_i = (_h = styles.colors) == null ? void 0 : _h.background) == null ? void 0 : _i.base,
      "--thn-tool-button-background-color": ((_j = styles.button) == null ? void 0 : _j.style) === ButtonStyleKind.Solid ? (_k = styles.colors) == null ? void 0 : _k.buttonBackground : "transparent",
      "--thn-tool-button-border": ((_l = styles.button) == null ? void 0 : _l.style) === ButtonStyleKind.Outline ? `solid 2px ${(_m = styles.colors) == null ? void 0 : _m.buttonBackground}` : "transparent",
      "--thn-tool-background-border": ((_o = (_n = styles.background) == null ? void 0 : _n.border) == null ? void 0 : _o.color) ? `solid ${cssVars["--thn-tool-background-border-thickness"]} ${styles.background.border.color}` : "none"
    });
  }
  addCssVariables(cssVars) {
    Object.keys(cssVars).forEach((key) => {
      var _a;
      (_a = this.rootDom) == null ? void 0 : _a.style.setProperty(key, cssVars[key] || "");
    });
  }
  getCssVariableValue(variableName) {
    return this.rootDom && getComputedStyle(this.rootDom).getPropertyValue(variableName);
  }
}
class LiteralsStore {
  constructor() {
    __publicField(this, "state", reactive({
      language: Locale.English,
      device: DeviceKind.Desktop,
      literals: {}
    }));
  }
  get device() {
    return this.state.device;
  }
  get language() {
    return this.state.language;
  }
  async initialize(language, device) {
    this.state.language = language != null ? language : Locale.English;
    this.state.device = device != null ? device : DeviceKind.Desktop;
    const literals = await __variableDynamicImportRuntimeHelper$(/* @__PURE__ */ Object.assign({ "../locales/ar.json": () => import("./p-components-ar.js"), "../locales/bg.json": () => import("./p-components-bg.js"), "../locales/ca.json": () => import("./p-components-ca.js"), "../locales/cs.json": () => import("./p-components-cs.js"), "../locales/da.json": () => import("./p-components-da.js"), "../locales/de.json": () => import("./p-components-de.js"), "../locales/el.json": () => import("./p-components-el.js"), "../locales/en.json": () => import("./p-components-en.js"), "../locales/es.json": () => import("./p-components-es.js"), "../locales/et.json": () => import("./p-components-et.js"), "../locales/eu.json": () => import("./p-components-eu.js"), "../locales/fi.json": () => import("./p-components-fi.js"), "../locales/fr.json": () => import("./p-components-fr.js"), "../locales/he.json": () => import("./p-components-he.js"), "../locales/hr.json": () => import("./p-components-hr.js"), "../locales/hu.json": () => import("./p-components-hu.js"), "../locales/id.json": () => import("./p-components-id.js"), "../locales/is.json": () => import("./p-components-is.js"), "../locales/it.json": () => import("./p-components-it.js"), "../locales/ja.json": () => import("./p-components-ja.js"), "../locales/ko.json": () => import("./p-components-ko.js"), "../locales/lt.json": () => import("./p-components-lt.js"), "../locales/nl.json": () => import("./p-components-nl.js"), "../locales/no.json": () => import("./p-components-no.js"), "../locales/pl.json": () => import("./p-components-pl.js"), "../locales/pt.json": () => import("./p-components-pt.js"), "../locales/ro.json": () => import("./p-components-ro.js"), "../locales/ru.json": () => import("./p-components-ru.js"), "../locales/sl.json": () => import("./p-components-sl.js"), "../locales/sv.json": () => import("./p-components-sv.js"), "../locales/th.json": () => import("./p-components-th.js"), "../locales/tr.json": () => import("./p-components-tr.js"), "../locales/uk.json": () => import("./p-components-uk.js"), "../locales/vi.json": () => import("./p-components-vi.js"), "../locales/zh-TW.json": () => import("./p-components-zh-TW.js"), "../locales/zh.json": () => import("./p-components-zh.js") }), `../locales/${this.state.language}.json`);
    this.state.literals = literals.default;
  }
  getLiteral(key, titleCase) {
    return titleCase ? toTitleCase(this.state.literals[key] || key) : this.state.literals[key] || key;
  }
  getLiteralAbb(key, titleCase) {
    const abbrKey = `${key}_abbr`;
    return this.getLiteral(abbrKey, titleCase);
  }
  getActivityLiteral(textKey, tokens = {}) {
    var _a;
    const interpolationValue = tokens[textKey];
    if (interpolationValue) {
      return (_a = this.state.literals[activityKindLiteralMap[textKey]]) == null ? void 0 : _a.replace("XXXXXX", interpolationValue);
    }
    return this.state.literals[activityKindLiteralMap[textKey]];
  }
  getPerkActiveLiteral(perkDescription, titleCase = false) {
    const activeText = perkDescription[this.state.language] || "";
    return titleCase ? toTitleCase(activeText) : activeText;
  }
  getPerkTooltipLiteral(textKey) {
    return this.state.literals[perkTooltipKindLiteralMap[textKey]];
  }
  getActiveModuleText(props, titleCase = false) {
    const activeText = props[this.device][this.language] || "";
    return titleCase ? toTitleCase(activeText) : activeText;
  }
  getLocaleImageUrl(imageSettings) {
    var _a;
    switch (imageSettings.languageType) {
      case LocaleImageKind.Multi:
        return (_a = imageSettings.urls[this.language || Locale.English]) == null ? void 0 : _a.edited;
      case LocaleImageKind.Single:
      default:
        return imageSettings.urls.edited;
    }
  }
  getLocaleImageAlt(imageSettings) {
    switch (imageSettings.languageType) {
      case LocaleImageKind.Multi:
        return imageSettings.alt[this.language || Locale.English];
      case LocaleImageKind.Single:
      default:
        return imageSettings.alt;
    }
  }
}
class ExtraDataStore {
  constructor() {
    __publicField(this, "initTime", Date.now());
    __publicField(this, "state", reactive({
      builderMode: false,
      firstVisitDate: null,
      hotelTimezone: "Europe/Madrid",
      defaultAssets: void 0,
      countdownTimestamp: void 0,
      tokens: {}
    }));
  }
  get countdownInitTime() {
    return this.initTime;
  }
  get builderMode() {
    return this.state.builderMode;
  }
  get defaultAssets() {
    return this.state.defaultAssets;
  }
  get countdownTimestamp() {
    return this.state.countdownTimestamp;
  }
  get tokens() {
    return this.state.tokens;
  }
  initialize(data) {
    this.state.builderMode = !!data.builderMode;
    this.state.firstVisitDate = data.firstVisitDate;
    this.state.hotelTimezone = data.hotelTimezone;
    this.state.hotelTimezoneOffset = data.hotelTimezoneOffset;
    this.state.defaultAssets = data.defaultAssets;
    this.state.countdownTimestamp = data.countdownTimestamp;
    this.state.tokens = data.tokens;
  }
  getCountdownTimestamp(kind, details) {
    const {
      date = Date.now(),
      timezone,
      days = 0,
      hours = 0,
      minutes = 0
    } = details;
    this.initTime = Date.now();
    if (kind === CountdownKind.Time) {
      const daysMs = days * 24 * 60 * 60 * 1e3;
      const hoursMs = hours * 60 * 60 * 1e3;
      const minutesMs = minutes * 60 * 1e3;
      const discountMs = this.state.firstVisitDate ? this.initTime - this.state.firstVisitDate : 0;
      return this.initTime + daysMs + hoursMs + minutesMs - discountMs;
    }
    if (kind === CountdownKind.Date && date) {
      const dateEndDate = new Date(date);
      dateEndDate.setHours(hours);
      dateEndDate.setMinutes(minutes);
      if (timezone === CountdownTimezone.Hotel) {
        if (!this.state.hotelTimezoneOffset && this.state.hotelTimezone) {
          const timezoneDate = new Date().toLocaleString("en-US", {
            timeZone: this.state.hotelTimezone
          });
          const timezoneMs = new Date(timezoneDate).getTime();
          const timezoneOffset = timezoneMs - new Date().getTime();
          dateEndDate.setTime(dateEndDate.getTime() - timezoneOffset);
        } else if (this.state.hotelTimezoneOffset) {
          dateEndDate.setTime(dateEndDate.getTime() - this.state.hotelTimezoneOffset);
        }
      }
      return dateEndDate.getTime();
    }
    return null;
  }
}
const defaultLiteralsStore = new LiteralsStore();
const stores = {};
const injectionKeys = {};
function getRootUid() {
  const instance = getCurrentInstance();
  return (instance == null ? void 0 : instance.uid) || 0;
}
function getRootElement() {
  var _a;
  const instance = getCurrentInstance();
  return (_a = instance == null ? void 0 : instance.proxy) == null ? void 0 : _a.$el;
}
function initializeStore(store) {
  var _a;
  const instance = getCurrentInstance();
  const hideFunction = (_a = instance == null ? void 0 : instance.exposed) == null ? void 0 : _a.hide;
  store.inited = true;
  store.hideFunction = hideFunction || (() => {
  });
}
function updateStore(toolProps) {
  const storeUid = getRootUid();
  const rootElement = getRootElement();
  const store = stores[storeUid];
  if (store.inited) {
    store.language = toolProps.language;
    store.rtl = toolProps.language === Locale.Arabic || toolProps.language === Locale.Hebrew;
    store.device = toolProps.device;
    store.extraData.initialize(toolProps.extraData);
    store.handlers.initialize(store.hideFunction, toolProps.actions);
    store.literals.initialize(toolProps.language, toolProps.device);
    store.styles.initialize(toolProps.styles, rootElement);
  } else {
    throw new Error(`error updating store ${storeUid}: store not inited`);
  }
}
function createStore(toolProps) {
  const uid = getRootUid();
  const storeInjectionKey = Symbol("useStore injection key");
  const store = reactive({
    uid,
    inited: false,
    language: Locale.English,
    device: DeviceKind.Desktop,
    hideFunction: () => {
    },
    extraData: new ExtraDataStore(),
    handlers: new HandlersStore(),
    literals: defaultLiteralsStore,
    styles: new StylesStore()
  });
  stores[uid] = store;
  injectionKeys[uid] = storeInjectionKey;
  provide(storeInjectionKey, store);
  provide("rootUID", uid);
  onMounted(() => {
    initializeStore(store);
    updateStore(toolProps);
  });
  return store;
}
function useStore() {
  const uid = inject("rootUID");
  if (uid !== void 0) {
    return inject(injectionKeys[uid]);
  }
  throw new Error("No UID found to load the store");
}
function useLiterals() {
  return defaultLiteralsStore;
}
const i18n = useLiterals();
let ids = 0;
function uniqueId() {
  ids += 1;
  return `extra-modules-${ids}`;
}
function getCommonProps(key) {
  const literal = i18n.getLiteral(key);
  const translation = {
    [i18n.language]: literal
  };
  return {
    sync: true,
    id: uniqueId(),
    mobile: translation,
    desktop: translation
  };
}
function getHeading(key = "") {
  const commonProps = getCommonProps(key);
  return {
    ...commonProps,
    moduleType: ToolModuleKind.Heading
  };
}
function getParagraph(key = "") {
  const commonProps = getCommonProps(key);
  return {
    ...commonProps,
    moduleType: ToolModuleKind.Paragraph
  };
}
function getButton(actionKind, key) {
  const commonProps = getCommonProps(key);
  return {
    ...commonProps,
    moduleType: ToolModuleKind.Button,
    behaviour: {
      type: actionKind
    }
  };
}
const moduleKindToSuccessMessageMap = {
  [ToolModuleKind.EmailCapture]: "Your email address has been successfully added to our list.",
  [ToolModuleKind.SavedSearch]: "We will send you an email with your search very soon.",
  [ToolModuleKind.Form]: "We have received your form submission correctly"
};
const buttonKindToSuccessMap = {
  [ButtonActionKind.ApplyPromoCode]: "Apply promocode",
  [ButtonActionKind.OpenUrl]: "Continue",
  [ButtonActionKind.CloseTool]: "Close",
  [ButtonActionKind.OpenBookingEngine]: "Book Now",
  [ButtonActionKind.OpenMailClient]: "Contact Now",
  [ButtonActionKind.CallPhoneNumber]: "Call Now"
};
const stepsWrapper = ref();
const ToolModuleKindsWithExtraSteps = [
  ToolModuleKind.SavedSearch,
  ToolModuleKind.EmailCapture,
  ToolModuleKind.Form
];
function hasModuleWithSteps(modules) {
  var _a;
  return ((_a = modules.find(
    (module2) => ToolModuleKindsWithExtraSteps.includes(module2.moduleType)
  )) == null ? void 0 : _a.moduleType) || "";
}
function hasLinkButton(modules) {
  return modules.find(
    (module2) => {
      var _a;
      return module2.moduleType === ToolModuleKind.Button && ((_a = module2.appearance) == null ? void 0 : _a.layout) === "link";
    }
  );
}
function getButtonModuleActionKind(modules) {
  var _a;
  return (_a = modules.find(
    (module2) => module2.moduleType === ToolModuleKind.Button
  )) == null ? void 0 : _a.behaviour.type;
}
function useSteps(modules) {
  const steps = {
    [DefaultStep.Main]: modules
  };
  const moduleWithSteps = hasModuleWithSteps(modules);
  if (moduleWithSteps) {
    const buttonModuleActionKind = getButtonModuleActionKind(modules);
    const buttonModuleText = buttonKindToSuccessMap[buttonModuleActionKind] || "Close";
    const successHeading = computed(() => getHeading("Thank you!"));
    const successParagraph = computed(() => getParagraph(
      moduleKindToSuccessMessageMap[moduleWithSteps]
    ));
    const successButton = computed(
      () => getButton(buttonModuleActionKind, buttonModuleText)
    );
    const failureHeading = computed(() => getHeading("There has been an error."));
    const failureParagraph = computed(() => getParagraph("Something went wrong. Please, try again later."));
    const failureButton = computed(() => getButton(ButtonActionKind.GoMainStep, "Back"));
    steps[DefaultStep.Success] = [
      successHeading.value,
      successParagraph.value,
      successButton.value
    ];
    steps[DefaultStep.Failure] = [
      failureHeading.value,
      failureParagraph.value,
      failureButton.value
    ];
    if (getButtonModuleActionKind(modules) === "submit") {
      steps[DefaultStep.Success].pop();
      steps[DefaultStep.Failure].pop();
    }
  }
  return steps;
}
const termsText = ref("Terms and conditions");
const modalOpen = ref(false);
function setTermsText(text) {
  termsText.value = text;
}
function toggleModal() {
  modalOpen.value = !modalOpen.value;
}
function resetModal() {
  modalOpen.value = false;
  termsText.value = "";
}
const _hoisted_1$j = ["data-builder-mode", "data-device", "data-content-alignment", "data-layout-kind", "data-text-direction"];
const _sfc_main$l = /* @__PURE__ */ defineComponent({
  __name: "Popup",
  props: {
    tool: {},
    context: {}
  },
  emits: [
    "hidden"
  ],
  setup(__props, { expose: __expose, emit: __emit }) {
    const layoutComponents = {};
    Object.keys(ToolLayoutKind).forEach((layout) => {
      const layoutId = ToolLayoutKind[layout];
      layoutComponents[layoutId] = defineAsyncComponent(() => __variableDynamicImportRuntimeHelper$(/* @__PURE__ */ Object.assign({ "./layouts/Circular.vue": () => import("./p-components-Circular.js"), "./layouts/CustomImage.vue": () => import("./p-components-CustomImage.js"), "./layouts/Fullscreen.vue": () => import("./p-components-Fullscreen.js"), "./layouts/FullscreenMini.vue": () => import("./p-components-FullscreenMini.js"), "./layouts/LowerNotification.vue": () => import("./p-components-LowerNotification.js"), "./layouts/NotificationTab.vue": () => import("./p-components-NotificationTab.js"), "./layouts/SideGradient.vue": () => import("./p-components-SideGradient.js"), "./layouts/Sidebar.vue": () => import("./p-components-Sidebar.js"), "./layouts/Square.vue": () => import("./p-components-Square.js"), "./layouts/SquareImage.vue": () => import("./p-components-SquareImage.js"), "./layouts/Sticky.vue": () => import("./p-components-Sticky.js"), "./layouts/StickyImage.vue": () => import("./p-components-StickyImage.js") }), `./layouts/${layout}.vue`));
    });
    const props = __props;
    const emit = __emit;
    const store = createStore(parseToolData({
      ...props,
      toolKind: ToolKind.Layer
    }));
    const componentRef = ref();
    const layoutProps = computed(() => {
      const {
        language,
        deviceViewport
      } = props.context;
      const {
        content: {
          modules
        },
        settings: {
          layout
        }
      } = props.tool;
      const steps = useSteps(modules);
      const hasSteps = hasModuleWithSteps(modules);
      return {
        language,
        device: deviceViewport,
        steps,
        hasSteps,
        layout
      };
    });
    const asyncComponent = computed(() => {
      var _a;
      if (!props.tool.settings.layout) {
        return null;
      }
      const layoutKind = (_a = props.tool.settings.layout) == null ? void 0 : _a.type;
      return layoutComponents[layoutKind];
    });
    function show() {
      var _a;
      (_a = componentRef.value) == null ? void 0 : _a.show();
    }
    function hide() {
      var _a;
      (_a = componentRef.value) == null ? void 0 : _a.hide();
    }
    onUpdated(() => {
      updateStore(parseToolData({
        ...props,
        toolKind: ToolKind.Layer
      }));
    });
    onMounted(() => {
      store.handlers.callHandler(ToolActionKind.Show);
    });
    function onHideLayout() {
      store.handlers.reset();
      resetModal();
      emit("hidden");
    }
    __expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      var _a, _b;
      return openBlock(), createElementBlock("div", {
        class: "thn--tool thn--tool-popup",
        "data-builder-mode": _ctx.context.builderMode,
        "data-device": _ctx.context.deviceViewport,
        "data-content-alignment": (_a = _ctx.tool.settings.layout) == null ? void 0 : _a.contentAlignment,
        "data-layout-kind": (_b = _ctx.tool.settings.layout) == null ? void 0 : _b.type,
        "data-text-direction": unref(store).rtl ? "rtl" : "ltr"
      }, [
        (openBlock(), createBlock(resolveDynamicComponent(asyncComponent.value), mergeProps({
          ref_key: "componentRef",
          ref: componentRef
        }, layoutProps.value, { onAfterLeave: onHideLayout }), null, 16))
      ], 8, _hoisted_1$j);
    };
  }
});
const Popup_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$i = ["data-builder-mode", "data-device", "data-content-alignment", "data-layout-kind", "data-text-direction"];
const _sfc_main$k = /* @__PURE__ */ defineComponent({
  __name: "Exit",
  props: {
    tool: {},
    context: {}
  },
  emits: [
    "hidden"
  ],
  setup(__props, { expose: __expose, emit: __emit }) {
    const layoutComponents = {};
    Object.keys(ToolLayoutKind).forEach((layout) => {
      const layoutId = ToolLayoutKind[layout];
      layoutComponents[layoutId] = defineAsyncComponent(() => __variableDynamicImportRuntimeHelper$(/* @__PURE__ */ Object.assign({ "./layouts/Circular.vue": () => import("./p-components-Circular.js"), "./layouts/CustomImage.vue": () => import("./p-components-CustomImage.js"), "./layouts/Fullscreen.vue": () => import("./p-components-Fullscreen.js"), "./layouts/FullscreenMini.vue": () => import("./p-components-FullscreenMini.js"), "./layouts/LowerNotification.vue": () => import("./p-components-LowerNotification.js"), "./layouts/NotificationTab.vue": () => import("./p-components-NotificationTab.js"), "./layouts/SideGradient.vue": () => import("./p-components-SideGradient.js"), "./layouts/Sidebar.vue": () => import("./p-components-Sidebar.js"), "./layouts/Square.vue": () => import("./p-components-Square.js"), "./layouts/SquareImage.vue": () => import("./p-components-SquareImage.js"), "./layouts/Sticky.vue": () => import("./p-components-Sticky.js"), "./layouts/StickyImage.vue": () => import("./p-components-StickyImage.js") }), `./layouts/${layout}.vue`));
    });
    const props = __props;
    const emit = __emit;
    const store = createStore(parseToolData({
      ...props,
      toolKind: ToolKind.Layer
    }));
    const componentRef = ref();
    const layoutProps = computed(() => {
      const {
        language,
        deviceViewport
      } = props.context;
      const {
        content: {
          modules
        },
        settings: {
          layout
        }
      } = props.tool;
      const steps = useSteps(modules);
      const hasSteps = hasModuleWithSteps(modules);
      return {
        language,
        device: deviceViewport,
        steps,
        hasSteps,
        layout
      };
    });
    const asyncComponent = computed(() => {
      var _a;
      if (!props.tool.settings.layout) {
        return null;
      }
      const layoutKind = (_a = props.tool.settings.layout) == null ? void 0 : _a.type;
      return layoutComponents[layoutKind];
    });
    function show() {
      var _a;
      (_a = componentRef.value) == null ? void 0 : _a.show();
    }
    function hide() {
      var _a;
      (_a = componentRef.value) == null ? void 0 : _a.hide();
    }
    onUpdated(() => {
      updateStore(parseToolData({
        ...props,
        toolKind: ToolKind.Layer
      }));
    });
    function onHideLayout() {
      store.handlers.reset();
      resetModal();
      emit("hidden");
    }
    __expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      var _a, _b;
      return openBlock(), createElementBlock("div", {
        class: "thn--tool thn--tool-popup",
        "data-builder-mode": _ctx.context.builderMode,
        "data-device": _ctx.context.deviceViewport,
        "data-content-alignment": (_a = _ctx.tool.settings.layout) == null ? void 0 : _a.contentAlignment,
        "data-layout-kind": (_b = _ctx.tool.settings.layout) == null ? void 0 : _b.type,
        "data-text-direction": unref(store).rtl ? "rtl" : "ltr"
      }, [
        (openBlock(), createBlock(resolveDynamicComponent(asyncComponent.value), mergeProps({
          ref_key: "componentRef",
          ref: componentRef
        }, layoutProps.value, { onAfterLeave: onHideLayout }), null, 16))
      ], 8, _hoisted_1$i);
    };
  }
});
const Exit_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$h = ["data-builder-mode", "data-device", "data-content-alignment", "data-layout-kind", "data-text-direction"];
const _sfc_main$j = /* @__PURE__ */ defineComponent({
  __name: "Inliner",
  props: {
    tool: {},
    context: {}
  },
  emits: [
    "hidden"
  ],
  setup(__props, { emit: __emit }) {
    const layoutComponents = {};
    Object.keys(ToolLayoutKind).forEach((layout) => {
      const layoutId = ToolLayoutKind[layout];
      layoutComponents[layoutId] = defineAsyncComponent(() => __variableDynamicImportRuntimeHelper$(/* @__PURE__ */ Object.assign({ "./layouts/inliner/Circular.vue": () => import("./p-components-Circular2.js"), "./layouts/inliner/CustomImage.vue": () => import("./p-components-CustomImage2.js"), "./layouts/inliner/Square.vue": () => import("./p-components-Square2.js"), "./layouts/inliner/SquareImage.vue": () => import("./p-components-SquareImage2.js") }), `./layouts/inliner/${layout}.vue`));
    });
    const props = __props;
    const emit = __emit;
    const store = createStore(parseToolData({
      ...props,
      toolKind: ToolKind.Inliner
    }));
    const componentRef = ref();
    const layoutProps = computed(() => {
      const {
        language,
        deviceViewport
      } = props.context;
      const {
        content: {
          modules
        },
        settings: {
          layout,
          embedded
        }
      } = props.tool;
      const steps = useSteps(modules);
      const hasSteps = hasModuleWithSteps(modules);
      return {
        language,
        device: deviceViewport,
        steps,
        hasSteps,
        layout,
        embedded
      };
    });
    const asyncComponent = computed(() => {
      var _a;
      if (!props.tool.settings.layout) {
        return null;
      }
      const layoutKind = (_a = props.tool.settings.layout) == null ? void 0 : _a.type;
      return layoutComponents[layoutKind];
    });
    onUpdated(() => {
      updateStore(parseToolData({
        ...props,
        toolKind: ToolKind.Layer
      }));
    });
    function onHideLayout() {
      store.handlers.reset();
      resetModal();
      emit("hidden");
    }
    return (_ctx, _cache) => {
      var _a, _b;
      return openBlock(), createElementBlock("div", {
        class: "thn--tool thn--tool-inliner",
        "data-builder-mode": _ctx.context.builderMode,
        "data-device": _ctx.context.deviceViewport,
        "data-content-alignment": (_a = _ctx.tool.settings.layout) == null ? void 0 : _a.contentAlignment,
        "data-layout-kind": (_b = _ctx.tool.settings.layout) == null ? void 0 : _b.type,
        "data-text-direction": unref(store).rtl ? "rtl" : "ltr"
      }, [
        (openBlock(), createBlock(resolveDynamicComponent(asyncComponent.value), mergeProps({
          ref_key: "componentRef",
          ref: componentRef
        }, layoutProps.value, { onAfterLeave: onHideLayout }), null, 16))
      ], 8, _hoisted_1$h);
    };
  }
});
const Inliner_vue_vue_type_style_index_0_lang = "";
var now = function() {
  return root$1.Date.now();
};
const now$1 = now;
var reWhitespace = /\s/;
function trimmedEndIndex(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {
  }
  return index;
}
var reTrimStart = /^\s+/;
function baseTrim(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
var symbolTag = "[object Symbol]";
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var FUNC_ERROR_TEXT = "Expected a function";
var nativeMax = Math.max, nativeMin = Math.min;
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now$1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now$1());
  }
  function debounced() {
    var time = now$1(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
const _sfc_main$i = /* @__PURE__ */ defineComponent({
  __name: "XClose",
  props: {
    triggerDismiss: { type: Boolean, default: true }
  },
  setup(__props) {
    const store = useStore();
    const props = __props;
    const onClick = debounce(() => {
      var _a;
      if (props.triggerDismiss === true) {
        (_a = store.handlers) == null ? void 0 : _a.callHandler(ToolActionKind.Dismiss);
      }
    }, 200, { leading: true, trailing: false });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-xclose",
        onMousedown: _cache[0] || (_cache[0] = withModifiers(
          (...args) => unref(onClick) && unref(onClick)(...args),
          ["left"]
        )),
        onClick: _cache[1] || (_cache[1] = (...args) => unref(onClick) && unref(onClick)(...args))
      }, [
        createVNode(unref(CrossIcon), { class: "thn--tool-xclose__svg" })
      ], 32);
    };
  }
});
const XClose_vue_vue_type_style_index_0_lang = "";
const defaultAppearance = {
  fontSize: 16,
  lineHeight: 16,
  letterSpacing: 0
};
function useTextAppearance(appearance = defaultAppearance, device = DeviceKind.Desktop, toolKind = ToolKind.Layer) {
  const {
    fontSize,
    lineHeight,
    letterSpacing
  } = appearance;
  const multiplier = device === DeviceKind.Mobile ? 0.8 : 1;
  const adjustedFontSize = Math.round(fontSize * multiplier);
  const adjustedLineHeight = Math.round(lineHeight);
  const adjustedLetterspacing = (letterSpacing != null ? letterSpacing : 0) / 100;
  return {
    fontSize: appendPx(adjustedFontSize < 14 && toolKind === ToolKind.Note ? 14 : adjustedFontSize),
    lineHeight: appendPx(adjustedLineHeight < 14 && toolKind === ToolKind.Note ? 14 : adjustedLineHeight),
    letterSpacing: !letterSpacing ? "normal" : appendEm(adjustedLetterspacing)
  };
}
const _hoisted_1$g = ["button-state", "moduleType", "data-module-id", "data-full-width"];
const _hoisted_2$9 = {
  key: 0,
  class: "thn--tool-button__back"
};
const _hoisted_3$5 = ["innerHTML"];
const _hoisted_4$5 = ["innerHTML"];
const _hoisted_5$3 = {
  key: 3,
  class: "thn--tool-button__sending loader"
};
const _hoisted_6$1 = /* @__PURE__ */ createElementVNode("div", { class: "la-ball-pulse" }, [
  /* @__PURE__ */ createElementVNode("div"),
  /* @__PURE__ */ createElementVNode("div"),
  /* @__PURE__ */ createElementVNode("div")
], -1);
const _hoisted_7$1 = [
  _hoisted_6$1
];
const _sfc_main$h = /* @__PURE__ */ defineComponent({
  __name: "Button",
  props: {
    moduleProps: {},
    hasExtraSteps: {},
    isLinkLayout: { type: Boolean },
    toolKind: {}
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "0bd033d9": buttonPositionArHebLeft.value,
      "6e8ca88a": buttonPositionArHebRight.value
    }));
    const store = useStore();
    const props = __props;
    const buttonPositionArHebLeft = computed(() => (store == null ? void 0 : store.rtl) ? "flex-end" : "none");
    const buttonPositionArHebRight = computed(() => (store == null ? void 0 : store.rtl) ? "flex-start" : "none");
    const text = computed(() => {
      var _a;
      return store == null ? void 0 : store.literals.getActiveModuleText(
        props.moduleProps,
        ((_a = store == null ? void 0 : store.styles.fonts[props.moduleProps.moduleType]) == null ? void 0 : _a.textTransform) === TextTransform.Titlecase
      );
    });
    const rootStyle = computed(
      () => useTextAppearance(props.moduleProps.appearance, store == null ? void 0 : store.device, props.toolKind)
    );
    const onClick = debounce(() => {
      if ((store == null ? void 0 : store.handlers.buttonState) !== ButtonState.Sending) {
        if (props.hasExtraSteps && !props.moduleProps.id.includes("extra")) {
          if (stepsWrapper.value) {
            stepsWrapper.value.scrollTop = 0;
          }
          store == null ? void 0 : store.handlers.callHandler(getButtonActionType(props.hasExtraSteps));
        } else if (props.moduleProps.behaviour.type === ButtonActionKind.GoMainStep) {
          store == null ? void 0 : store.handlers.goBackToMainStep();
        } else {
          const buttonActionType = getButtonActionType(props.moduleProps.behaviour.type);
          store == null ? void 0 : store.handlers.callHandler(buttonActionType, props.moduleProps.id);
        }
      }
    }, 200, { leading: true, trailing: false });
    return (_ctx, _cache) => {
      var _a, _b, _c;
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          "thn--tool-button",
          { "inline-layout": _ctx.isLinkLayout }
        ]),
        "button-state": (_a = unref(store)) == null ? void 0 : _a.handlers.buttonState,
        style: normalizeStyle(rootStyle.value),
        moduleType: _ctx.moduleProps.moduleType,
        "data-module-id": _ctx.moduleProps.id,
        "data-full-width": (_b = _ctx.moduleProps.appearance) == null ? void 0 : _b.fullWidth,
        onMousedown: _cache[0] || (_cache[0] = withModifiers(
          (...args) => unref(onClick) && unref(onClick)(...args),
          ["left"]
        )),
        onClick: _cache[1] || (_cache[1] = (...args) => unref(onClick) && unref(onClick)(...args))
      }, [
        !_ctx.isLinkLayout ? (openBlock(), createElementBlock("div", _hoisted_2$9)) : createCommentVNode("", true),
        !_ctx.isLinkLayout ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: "thn--tool-button__label",
          innerHTML: text.value
        }, null, 8, _hoisted_3$5)) : (openBlock(), createElementBlock("span", {
          key: 2,
          innerHTML: text.value
        }, null, 8, _hoisted_4$5)),
        ((_c = unref(store)) == null ? void 0 : _c.handlers.buttonState) === unref(ButtonState).Sending && !_ctx.isLinkLayout ? (openBlock(), createElementBlock("div", _hoisted_5$3, _hoisted_7$1)) : createCommentVNode("", true)
      ], 46, _hoisted_1$g);
    };
  }
});
const Button_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$f = ["innerHTML", "moduleType", "data-module-id"];
const _sfc_main$g = /* @__PURE__ */ defineComponent({
  __name: "Text",
  props: {
    moduleProps: {},
    toolKind: {}
  },
  setup(__props) {
    const moduleKindToDefault = {
      [ToolModuleKind.Heading]: {
        fontSize: 24,
        lineHeight: 24
      },
      [ToolModuleKind.Paragraph]: {
        fontSize: 16,
        lineHeight: 16
      },
      [ToolModuleKind.Button]: {
        fontSize: 18,
        lineHeight: 18
      }
    };
    const store = useStore();
    const props = __props;
    const text = computed(() => {
      var _a;
      return store == null ? void 0 : store.literals.getActiveModuleText(
        props.moduleProps,
        ((_a = store == null ? void 0 : store.styles.fonts[props.moduleProps.moduleType]) == null ? void 0 : _a.textTransform) === TextTransform.Titlecase
      );
    });
    const textAppearance = computed(
      () => props.moduleProps.appearance || moduleKindToDefault[props.moduleProps.moduleType]
    );
    const textStyle = computed(
      () => useTextAppearance(textAppearance.value, store == null ? void 0 : store.device, props.toolKind)
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-text",
        style: normalizeStyle(textStyle.value),
        innerHTML: text.value,
        moduleType: _ctx.moduleProps.moduleType,
        "data-module-id": _ctx.moduleProps.id
      }, null, 12, _hoisted_1$f);
    };
  }
});
const Text_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$e = ["innerHTML", "data-module-id"];
const _sfc_main$f = /* @__PURE__ */ defineComponent({
  __name: "Activity",
  props: {
    moduleProps: {}
  },
  setup(__props) {
    const store = useStore();
    const props = __props;
    const text = computed(
      () => store == null ? void 0 : store.literals.getActivityLiteral(
        props.moduleProps.textKey,
        store == null ? void 0 : store.extraData.tokens
      )
    );
    const rootStyle = computed(() => useTextAppearance(props.moduleProps.appearance, store == null ? void 0 : store.device));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-activity",
        innerHTML: text.value,
        "data-module-id": _ctx.moduleProps.id,
        style: normalizeStyle(rootStyle.value)
      }, null, 12, _hoisted_1$e);
    };
  }
});
const Activity_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$d = ["data-module-id"];
const _sfc_main$e = /* @__PURE__ */ defineComponent({
  __name: "Icon",
  props: {
    moduleProps: {}
  },
  setup(__props) {
    const props = __props;
    const iconModule = computed(() => {
      const iconComponentName = `${toPascalCase(props.moduleProps.value)}Icon`;
      return defineAsyncComponent(() => import(`@thehotelsnetwork/icons/vue/personalization/${iconComponentName}.js`));
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-icon",
        "data-module-id": props.moduleProps.id,
        "data-module-special": true
      }, [
        createVNode(unref(iconModule), { class: "thn--tool-icon__svg" })
      ], 8, _hoisted_1$d);
    };
  }
});
const Icon_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$c = ["data-position", "data-device", "data-builder-mode", "data-text-direction"];
const _hoisted_2$8 = /* @__PURE__ */ createElementVNode("div", { class: "thn--tool-note__back" }, null, -1);
const _hoisted_3$4 = { class: "thn--tool-note__content" };
const _hoisted_4$4 = { class: "thn--tool-note__modules__wrapper" };
const _sfc_main$d = /* @__PURE__ */ defineComponent({
  __name: "Note",
  props: {
    tool: {},
    context: {}
  },
  emits: [
    "hide",
    "hidden"
  ],
  setup(__props, { expose: __expose, emit: __emit }) {
    useCssVars((_ctx) => ({
      "4e77fdee": flipmarginRight.value,
      "e9c7610c": flipmarginLeft.value
    }));
    const noteModuleKindToComponentMap = {
      [ToolModuleKind.Paragraph]: _sfc_main$g,
      [ToolModuleKind.Activity]: _sfc_main$f,
      [ToolModuleKind.Button]: _sfc_main$h
    };
    const props = __props;
    const emit = __emit;
    const store = createStore(parseToolData({
      ...props,
      toolKind: ToolKind.Note
    }));
    const rootDom = ref();
    const hidden = ref(false);
    const { height: noteComponentHeight } = useElementSize(rootDom);
    const layout = computed(() => {
      const {
        content: {
          modules
        }
      } = props.tool;
      return {
        hasLinkLayoutButton: !!hasLinkButton(modules)
      };
    });
    const iconProps = computed(() => props.tool.content.modules.find((module2) => module2.moduleType === ToolModuleKind.Icon));
    const restModules = computed(() => props.tool.content.modules.filter(
      (module2) => module2.moduleType !== ToolModuleKind.Icon
    ));
    const { isSwiping, lengthX } = useSwipe(rootDom, {
      onSwipeEnd: () => {
        if (Math.abs(lengthX.value) > 150) {
          store.handlers.callHandler(ToolActionKind.Dismiss);
        }
      }
    });
    const rootStyle = computed(() => {
      const swipeStyles = {};
      if (isSwiping.value && rootDom.value) {
        const translateValue = -rootDom.value.getBoundingClientRect().width / 2 - lengthX.value;
        swipeStyles.transform = `translateX(${translateValue}px)`;
        swipeStyles.opacity = (100 - Math.abs(lengthX.value / 3)) / 100;
      }
      return {
        ...swipeStyles
      };
    });
    const transitionName = computed(() => {
      const { position } = props.tool.settings.devices[props.context.deviceViewport];
      return getTransitionName("fade", position);
    });
    const flipmarginRight = computed(() => (store == null ? void 0 : store.rtl) ? "none" : "12px");
    const flipmarginLeft = computed(() => (store == null ? void 0 : store.rtl) ? "12px" : "none");
    function show() {
      hidden.value = false;
    }
    function hide() {
      emit("hide");
      hidden.value = true;
    }
    function onHideLayout() {
      emit("hidden");
    }
    onUpdated(() => {
      updateStore(parseToolData({
        ...props,
        toolKind: ToolKind.Note
      }));
    });
    onMounted(() => {
      store.handlers.callHandler(ToolActionKind.Show);
      if (props.tool.settings.timing.pagetime) {
        setTimeout(() => {
          store.handlers.callHandler(ToolActionKind.Hide);
          hide();
        }, Number(props.tool.settings.timing.pagetime) * 1e3);
      }
    });
    __expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        name: transitionName.value,
        appear: "",
        onAfterLeave: onHideLayout
      }, {
        default: withCtx(() => [
          withDirectives(createElementVNode("div", {
            class: "thn--tool thn--tool-note",
            ref_key: "rootDom",
            ref: rootDom,
            style: normalizeStyle(rootStyle.value),
            "data-position": _ctx.tool.settings.devices[_ctx.context.deviceViewport].position,
            "data-device": _ctx.context.deviceViewport,
            "data-builder-mode": _ctx.context.builderMode,
            "data-text-direction": unref(store).rtl ? "rtl" : "ltr"
          }, [
            _hoisted_2$8,
            createElementVNode("div", _hoisted_3$4, [
              iconProps.value ? (openBlock(), createBlock(_sfc_main$e, {
                key: 0,
                class: normalizeClass(["thn--tool-note__icon", [unref(noteComponentHeight) > 72 ? "icon-top" : "icon-center"]]),
                "data-module-id": iconProps.value.id,
                "data-module-special": true,
                "module-props": iconProps.value
              }, null, 8, ["class", "data-module-id", "module-props"])) : createCommentVNode("", true),
              createElementVNode("div", {
                class: normalizeClass([
                  "thn--tool-note__modules",
                  { "inline-layout": layout.value.hasLinkLayoutButton }
                ]),
                "data-add-module": true
              }, [
                createElementVNode("div", _hoisted_4$4, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(restModules.value, (moduleProps, moduleIndex) => {
                    return openBlock(), createBlock(resolveDynamicComponent(noteModuleKindToComponentMap[moduleProps.moduleType]), mergeProps({
                      class: "thn--tool-note-component",
                      key: moduleIndex,
                      "is-link-layout": layout.value.hasLinkLayoutButton,
                      "tool-kind": unref(ToolKind).Note
                    }, {
                      moduleProps
                    }), null, 16, ["is-link-layout", "tool-kind"]);
                  }), 128))
                ])
              ], 2)
            ]),
            createVNode(_sfc_main$i)
          ], 12, _hoisted_1$c), [
            [vShow, !hidden.value]
          ])
        ]),
        _: 1
      }, 8, ["name"]);
    };
  }
});
const Note_vue_vue_type_style_index_0_lang = "";
var StepState = /* @__PURE__ */ ((StepState2) => {
  StepState2["Active"] = "active";
  StepState2["Next"] = "next";
  StepState2["Previous"] = "previous";
  return StepState2;
})(StepState || {});
const defaultStyles = {
  colors: {
    heading: "#CCCCCC",
    paragraph: "#CCCCCC",
    icon: "#000000",
    buttonText: "#ffffff",
    buttonBackground: "#000000",
    background: {
      base: "#ffffff"
    }
  },
  fonts: {
    paragraph: {
      spec: {
        key: "Open+Sans",
        name: "Open Sans",
        cssName: "Open Sans",
        type: "sans-serif",
        fontType: FontType.Google,
        source: ""
      },
      style: "bold",
      textTransform: TextTransform.None
    },
    button: {
      spec: {
        key: "Open+Sans",
        name: "Open Sans",
        cssName: "Open Sans",
        type: "sans-serif",
        fontType: FontType.Google,
        source: ""
      },
      style: "bold",
      textTransform: TextTransform.None
    }
  },
  button: {
    style: ButtonStyleKind.Solid,
    cornerRadius: {
      kind: RadiusKind.Rounded
    },
    padding: {
      format: MeasureUnit.Pixels,
      right: 8,
      left: 8,
      top: 24,
      bottom: 24
    }
  },
  background: {
    opacity: 100,
    cornerRadius: {
      kind: RadiusKind.Rounded
    },
    image: {
      opacity: 10,
      alt: "alt text for background image",
      urls: {
        edited: "https://s3-eu-west-1.amazonaws.com/popups-photos/welcome/back_photo/1440_820/75b2b42a6a40e1a8186b2823c50c7c1a.jpg"
      }
    }
  },
  overlay: {
    opacity: 10,
    color: "#000000"
  }
};
const _hoisted_1$b = { class: "thn--tool-back" };
const _hoisted_2$7 = /* @__PURE__ */ createElementVNode("div", { class: "thn--tool-back__color" }, null, -1);
const _hoisted_3$3 = ["image-loaded"];
const _hoisted_4$3 = ["alt", "src"];
const _sfc_main$c = /* @__PURE__ */ defineComponent({
  __name: "Back",
  setup(__props) {
    useCssVars((_ctx) => ({
      "3a295ff2": flipBackground.value
    }));
    const store = useStore();
    const flipBackground = computed(() => (store == null ? void 0 : store.rtl) ? "scaleX(-1)" : "none");
    const imageLoaded = ref(false);
    const imageUrl = computed(() => store == null ? void 0 : store.styles.backgroundImage);
    const imageAlt = computed(() => store == null ? void 0 : store.styles.backgroundImageAlt);
    function onLoadBackPhoto() {
      imageLoaded.value = true;
    }
    watch(() => store == null ? void 0 : store.styles.backgroundImage, (oldVal, newVal) => {
      if (newVal !== oldVal) {
        imageLoaded.value = false;
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$b, [
        _hoisted_2$7,
        !!imageUrl.value ? (openBlock(), createElementBlock("div", {
          key: 0,
          "image-loaded": imageLoaded.value,
          class: "thn--tool-back__image"
        }, [
          createElementVNode("img", {
            onLoad: onLoadBackPhoto,
            alt: imageAlt.value,
            src: imageUrl.value
          }, null, 40, _hoisted_4$3)
        ], 8, _hoisted_3$3)) : createCommentVNode("", true)
      ]);
    };
  }
});
const Back_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$a = ["data-to-left"];
const paddingX$1 = 20;
const paddingY = 10;
const arrowH = 8;
const arrowX = 10;
const _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "Tooltip",
  props: {
    autoHide: {},
    backColor: { default: "#88001e" },
    color: { default: "#ffffff" }
  },
  setup(__props, { expose: __expose }) {
    useCssVars((_ctx) => ({
      "16deb290": _ctx.backColor,
      "7cbdfd42": _ctx.color,
      "85e82942": unref(appendPx)(paddingY),
      "85e82980": unref(appendPx)(paddingX$1),
      "2b32d690": unref(appendPx)(arrowX),
      "2b32da70": unref(appendPx)(arrowH)
    }));
    const store = useStore();
    const props = __props;
    const timer = ref();
    const rootRef = ref();
    const showing = ref(false);
    const message = ref();
    const position = ref();
    const { width, height } = useElementSize(rootRef);
    const toLeft = computed(() => {
      if (position.value && (store == null ? void 0 : store.styles.rootElement)) {
        const {
          left: containerLeft,
          width: containerWidth
        } = store.styles.rootElement.getBoundingClientRect();
        return position.value.left > containerLeft + containerWidth / 2;
      }
      return false;
    });
    const rootStyle = computed(() => {
      if (position.value && rootRef.value) {
        const {
          left,
          top
        } = position.value;
        const arrowDistance = arrowX + arrowH;
        const totalHeight = height.value + paddingY * 2 + arrowH;
        const totalWidth = width.value + paddingX$1 * 2;
        return {
          top: appendPx(top - totalHeight),
          left: appendPx(left - (toLeft.value ? totalWidth - arrowDistance : arrowDistance))
        };
      }
      return {};
    });
    function clearTimer() {
      if (timer.value) {
        clearTimeout(timer.value);
        timer.value = null;
      }
    }
    function hide() {
      clearTimer();
      showing.value = false;
    }
    function show(text, targetPosition) {
      clearTimer();
      showing.value = true;
      position.value = targetPosition;
      message.value = text;
      if (props.autoHide) {
        timer.value = setTimeout(() => {
          hide();
        }, props.autoHide);
      }
    }
    __expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, { name: "fade-tooltip" }, {
        default: withCtx(() => [
          withDirectives(createElementVNode("div", {
            class: "thn--tool-tooltip",
            ref_key: "rootRef",
            ref: rootRef,
            style: normalizeStyle(rootStyle.value)
          }, [
            createElementVNode("span", {
              class: "thn--tool-tooltip__arrow",
              "data-to-left": toLeft.value
            }, null, 8, _hoisted_1$a),
            createTextVNode(" " + toDisplayString(message.value), 1)
          ], 4), [
            [vShow, showing.value]
          ])
        ]),
        _: 1
      });
    };
  }
});
const Tooltip_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$9 = {
  class: "thn--tool-input",
  ref: "rootRef"
};
const _hoisted_2$6 = ["required", "disabled", "type", "name", "error", "placeholder"];
const paddingX = 10;
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "Input",
  props: {
    placeholder: { default: "" },
    type: {},
    errorMessage: { default: "" },
    required: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    useCssVars((_ctx) => ({
      "37a27ce6": unref(appendPx)(paddingX)
    }));
    const props = __props;
    const emit = __emit;
    const inputRef = ref();
    const errorTooltipRef = ref();
    function onInput() {
      emit("update:modelValue", inputRef.value.value);
    }
    function hideError() {
      errorTooltipRef.value.hide();
    }
    function showError() {
      var _a;
      const {
        top,
        left
      } = ((_a = inputRef.value) == null ? void 0 : _a.getBoundingClientRect()) || {};
      errorTooltipRef.value.show(props.errorMessage, {
        top,
        left: left + paddingX
      });
    }
    function validate() {
      const isValid = inputRef.value.validity.valid;
      if (!isValid) {
        showError();
      }
      return isValid;
    }
    function clear() {
      inputRef.value.value = "";
    }
    __expose({
      clear,
      validate
    });
    return (_ctx, _cache) => {
      var _a;
      return openBlock(), createElementBlock("div", _hoisted_1$9, [
        createVNode(_sfc_main$b, {
          ref_key: "errorTooltipRef",
          ref: errorTooltipRef,
          "auto-hide": 3e3
        }, null, 512),
        createElementVNode("input", {
          class: "thn--tool-input__input",
          required: _ctx.required,
          ref_key: "inputRef",
          ref: inputRef,
          disabled: _ctx.disabled,
          type: _ctx.type || "email",
          name: _ctx.type || "email",
          error: (_a = errorTooltipRef.value) == null ? void 0 : _a.showing,
          placeholder: _ctx.placeholder,
          onInput,
          onMousedown: hideError
        }, null, 40, _hoisted_2$6)
      ], 512);
    };
  }
});
const Input_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$8 = ["checked", "disabled"];
const _hoisted_2$5 = /* @__PURE__ */ createElementVNode("input", {
  class: "tool--checkbox__input",
  type: "checkbox"
}, null, -1);
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "Checkbox",
  props: {
    errorMessage: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    id: {
      type: String
    }
  },
  emits: [
    "update:modelValue"
  ],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const checkmarkDom = ref();
    const isChecked = ref(props.checked);
    const errorTooltipRef = ref();
    function hideError() {
      errorTooltipRef.value.hide();
    }
    const onClick = debounce(() => {
      isChecked.value = !isChecked.value;
      hideError();
      emit("update:modelValue", isChecked.value);
    }, 200, { leading: true, trailing: false });
    function showError() {
      var _a;
      const {
        top,
        left,
        width
      } = ((_a = checkmarkDom.value) == null ? void 0 : _a.getBoundingClientRect()) || {};
      errorTooltipRef.value.show(props.errorMessage, {
        top,
        left: left + width / 2
      });
    }
    function validate() {
      const isValid = !props.required || !!isChecked.value;
      if (!isValid) {
        showError();
      }
      return isValid;
    }
    __expose({
      validate,
      isChecked,
      id: props.id
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "tool--checkbox",
        onMousedown: _cache[0] || (_cache[0] = withModifiers(
          (...args) => unref(onClick) && unref(onClick)(...args),
          ["left"]
        )),
        onClick: _cache[1] || (_cache[1] = (...args) => unref(onClick) && unref(onClick)(...args)),
        checked: isChecked.value,
        disabled: __props.disabled
      }, [
        createVNode(_sfc_main$b, {
          ref_key: "errorTooltipRef",
          ref: errorTooltipRef,
          "auto-hide": 3e3
        }, null, 512),
        _hoisted_2$5,
        createElementVNode("span", {
          class: "tool--checkbox__checkmark",
          ref_key: "checkmarkDom",
          ref: checkmarkDom
        }, null, 512)
      ], 40, _hoisted_1$8);
    };
  }
});
const Checkbox_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$7 = { class: "thn--tool-terms__modal" };
const _hoisted_2$4 = ["innerHTML"];
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "Modal",
  props: {
    termsText: {}
  },
  setup(__props) {
    const toggleModal$1 = debounce(toggleModal, 200, { leading: true, trailing: false });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$7, [
        createElementVNode("div", {
          class: "thn--tool-terms__modal-text",
          innerHTML: _ctx.termsText
        }, null, 8, _hoisted_2$4),
        createElementVNode("div", {
          class: "thn--tool-xclose",
          onMousedown: _cache[0] || (_cache[0] = withModifiers(
            (...args) => unref(toggleModal$1) && unref(toggleModal$1)(...args),
            ["left"]
          )),
          onClick: _cache[1] || (_cache[1] = (...args) => unref(toggleModal$1) && unref(toggleModal$1)(...args))
        }, [
          createVNode(unref(CrossIcon), { class: "thn--tool-xclose__svg" })
        ], 32)
      ]);
    };
  }
});
const Modal_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$6 = ["closeOnClick"];
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "Overlay",
  props: {
    closeOnClickOutside: { type: Boolean }
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "aded1010": flipBackground.value
    }));
    const store = useStore();
    const props = __props;
    const flipBackground = computed(() => (store == null ? void 0 : store.rtl) ? "scaleX(-1)" : "none");
    const onClickBack = debounce(() => {
      if (props.closeOnClickOutside) {
        store == null ? void 0 : store.handlers.callHandler(ToolActionKind.Dismiss);
      }
    }, 200, { leading: true, trailing: false });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-overlay",
        onMousedown: _cache[0] || (_cache[0] = withModifiers(
          (...args) => unref(onClickBack) && unref(onClickBack)(...args),
          ["left"]
        )),
        onClick: _cache[1] || (_cache[1] = (...args) => unref(onClickBack) && unref(onClickBack)(...args)),
        closeOnClick: props.closeOnClickOutside
      }, null, 40, _hoisted_1$6);
    };
  }
});
const Overlay_vue_vue_type_style_index_0_lang = "";
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "SlideDown",
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["transition-start", "transition-end"],
  setup(__props, { emit: __emit }) {
    useCssVars((_ctx) => ({
      "73b11a58": heightPx.value
    }));
    const props = __props;
    const emit = __emit;
    const contentEl = ref();
    const wrapperEl = ref();
    const { height } = useElementSize(contentEl);
    const heightPx = computed(() => `${height.value}px`);
    watchOnce(() => props.modelValue, (value) => {
      if (value) {
        emit("transition-start");
      }
    });
    useEventListener(wrapperEl, "transitionend", () => {
      emit("transition-end");
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "wrapperEl",
        ref: wrapperEl,
        class: normalizeClass(["wrapper", { "open": props.modelValue }])
      }, [
        createElementVNode("div", {
          ref_key: "contentEl",
          ref: contentEl,
          class: "content"
        }, [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ], 512)
      ], 2);
    };
  }
});
const SlideDown_vue_vue_type_style_index_0_scoped_a43fc71f_lang = "";
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const SlideDown = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["__scopeId", "data-v-a43fc71f"]]);
const _hoisted_1$5 = { class: "thn--tool-terms" };
const _hoisted_2$3 = { key: 0 };
const _hoisted_3$2 = {
  key: 0,
  class: "thn--tool-terms__label"
};
const _hoisted_4$2 = ["href"];
const _hoisted_5$2 = ["onMousedown"];
const _hoisted_6 = {
  key: 4,
  class: "thn--tool-terms__label thn--tool-terms__label--tag"
};
const _hoisted_7 = {
  key: 0,
  class: "thn--tool-terms__label"
};
const _hoisted_8 = ["href", "target"];
const _hoisted_9 = ["onMousedown"];
const _hoisted_10 = {
  key: 4,
  class: "thn--tool-terms__label thn--tool-terms__label--tag"
};
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "Terms",
  props: {
    customTerms: {},
    propertyTerms: {},
    termsInherited: { type: Boolean },
    termsRequired: { type: Boolean },
    disabled: { type: Boolean },
    appearanceStyle: {}
  },
  setup(__props, { expose: __expose }) {
    const store = useStore();
    const props = __props;
    const filteredCustomTerms = computed(() => {
      var _a, _b;
      const propertyTermIds = ((_a = props.propertyTerms) != null ? _a : []).map((term) => term.id);
      return ((_b = props.customTerms) != null ? _b : []).filter((customTerm) => !propertyTermIds.includes(customTerm.termId));
    });
    const termRefs = ref([]);
    const isTitleCase = computed(
      () => {
        var _a;
        return ((_a = store == null ? void 0 : store.styles.fonts.formFieldName) == null ? void 0 : _a.textTransform) === TextTransform.Titlecase;
      }
    );
    const errorMessage = computed(() => store == null ? void 0 : store.literals.getLiteral("You must agree to the Terms & Conditions first"));
    const optionalLabel = store == null ? void 0 : store.literals.getLiteral("(Optional)");
    const defaultTermsLabel = computed(() => store == null ? void 0 : store.literals.getLiteral("Terms_default_label", isTitleCase.value));
    const defaultTerms = computed(() => store == null ? void 0 : store.literals.getLiteral("Terms_default"));
    function validate() {
      const response = {
        valid: termRefs.value.every((termRef) => termRef == null ? void 0 : termRef.validate()),
        terms: []
      };
      if (response.valid) {
        response.terms = termRefs.value.map((termRef) => ({
          termId: termRef.id,
          isChecked: termRef.isChecked
        }));
      }
      return response;
    }
    function getTermLabel(moduleTerms) {
      var _a, _b;
      return isTitleCase.value ? toTitleCase(((_a = moduleTerms.content.languages[(store == null ? void 0 : store.literals.language) || "en"]) == null ? void 0 : _a.label) || "") : (_b = moduleTerms.content.languages[(store == null ? void 0 : store.literals.language) || "en"]) == null ? void 0 : _b.label;
    }
    function getTermText(moduleTerms) {
      var _a;
      return (_a = moduleTerms.content.languages[(store == null ? void 0 : store.literals.language) || "en"]) == null ? void 0 : _a.text;
    }
    function getTermLink(moduleTerms) {
      var _a;
      return (_a = moduleTerms.content.languages[(store == null ? void 0 : store.literals.language) || "en"]) == null ? void 0 : _a.url;
    }
    function isNotLinkedTerm(moduleTerms) {
      return moduleTerms.content.linkedTo === TermsLinkKind.NotLinked;
    }
    function isUrlTerm(moduleTerms) {
      return moduleTerms.content.linkedTo === TermsLinkKind.Url;
    }
    function isPopupTerm(moduleTerms) {
      return [TermsLinkKind.CustomText].includes(moduleTerms.content.linkedTo);
    }
    function isDefaultPopupTerm(moduleTerms) {
      return [TermsLinkKind.DefaultText].includes(moduleTerms.content.linkedTo);
    }
    function openTerms(moduleTerms) {
      setTermsText(getTermText(moduleTerms) || "");
      toggleModal();
    }
    function openDefaultTerms() {
      setTermsText(defaultTerms.value || "");
      toggleModal();
    }
    __expose({
      validate
    });
    return (_ctx, _cache) => {
      var _a;
      return openBlock(), createElementBlock("div", _hoisted_1$5, [
        _ctx.termsInherited && ((_a = _ctx.propertyTerms) == null ? void 0 : _a.length) ? (openBlock(), createElementBlock("div", _hoisted_2$3, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.propertyTerms, (propertyTerm, index) => {
            return openBlock(), createElementBlock("div", {
              class: "thn--tool-terms__item",
              key: index
            }, [
              createVNode(_sfc_main$9, {
                ref_for: true,
                ref: (ref2) => termRefs.value[index] = ref2,
                "error-message": errorMessage.value,
                class: "thn--tool-terms__checkbox",
                disabled: !!_ctx.disabled,
                required: _ctx.termsRequired,
                name: "terms-inherit",
                id: propertyTerm.id
              }, null, 8, ["error-message", "disabled", "required", "id"]),
              isNotLinkedTerm(propertyTerm) ? (openBlock(), createElementBlock("div", _hoisted_3$2, toDisplayString(getTermLabel(propertyTerm)), 1)) : isUrlTerm(propertyTerm) ? (openBlock(), createElementBlock("a", {
                key: 1,
                class: "thn--tool-terms__label thn--tool-terms__label--url",
                href: getTermLink(propertyTerm),
                target: "terms-inherit"
              }, [
                createElementVNode("span", null, toDisplayString(getTermLabel(propertyTerm)), 1),
                createVNode(unref(ArrowUpRightIcon), { class: "thn--tool-terms__label--icon" })
              ], 8, _hoisted_4$2)) : isPopupTerm(propertyTerm) ? (openBlock(), createElementBlock("div", {
                key: 2,
                class: "thn--tool-terms__label thn--tool-terms__label--popup",
                onMousedown: ($event) => openTerms(propertyTerm)
              }, toDisplayString(getTermLabel(propertyTerm)), 41, _hoisted_5$2)) : isDefaultPopupTerm(propertyTerm) ? (openBlock(), createElementBlock("div", {
                key: 3,
                class: "thn--tool-terms__label thn--tool-terms__label--popup",
                onMousedown: _cache[0] || (_cache[0] = ($event) => openDefaultTerms())
              }, toDisplayString(defaultTermsLabel.value), 33)) : createCommentVNode("", true),
              !_ctx.termsRequired ? (openBlock(), createElementBlock("div", _hoisted_6, toDisplayString(unref(optionalLabel)), 1)) : createCommentVNode("", true)
            ]);
          }), 128))
        ])) : createCommentVNode("", true),
        (openBlock(true), createElementBlock(Fragment, null, renderList(filteredCustomTerms.value, ({
          termId,
          isRequired,
          term
        }, index) => {
          return openBlock(), createElementBlock("div", {
            class: "thn--tool-terms__item",
            key: index
          }, [
            createVNode(_sfc_main$9, {
              ref_for: true,
              ref: (ref2) => {
                var _a2;
                return _ctx.termsInherited && ((_a2 = _ctx.propertyTerms) == null ? void 0 : _a2.length) ? termRefs.value[index + _ctx.propertyTerms.length] = ref2 : termRefs.value[index] = ref2;
              },
              "error-message": errorMessage.value,
              class: "thn--tool-terms__checkbox",
              disabled: !!_ctx.disabled,
              required: isRequired,
              name: `terms-${index}`,
              id: termId
            }, null, 8, ["error-message", "disabled", "required", "name", "id"]),
            isNotLinkedTerm(term) ? (openBlock(), createElementBlock("div", _hoisted_7, toDisplayString(getTermLabel(term)), 1)) : isUrlTerm(term) ? (openBlock(), createElementBlock("a", {
              key: 1,
              class: "thn--tool-terms__label thn--tool-terms__label--url",
              href: getTermLink(term),
              target: `terms-${index}`
            }, [
              createElementVNode("span", null, toDisplayString(getTermLabel(term)), 1),
              createVNode(unref(ArrowUpRightIcon), { class: "thn--tool-terms__label--icon" })
            ], 8, _hoisted_8)) : isPopupTerm(term) ? (openBlock(), createElementBlock("div", {
              key: 2,
              class: "thn--tool-terms__label thn--tool-terms__label--popup",
              onMousedown: ($event) => openTerms(term)
            }, toDisplayString(getTermLabel(term)), 41, _hoisted_9)) : isDefaultPopupTerm(term) ? (openBlock(), createElementBlock("div", {
              key: 3,
              class: "thn--tool-terms__label thn--tool-terms__label--popup",
              onMousedown: _cache[1] || (_cache[1] = ($event) => openDefaultTerms())
            }, toDisplayString(defaultTermsLabel.value), 33)) : createCommentVNode("", true),
            !isRequired ? (openBlock(), createElementBlock("div", _hoisted_10, toDisplayString(unref(optionalLabel)), 1)) : createCommentVNode("", true)
          ]);
        }), 128))
      ]);
    };
  }
});
const Terms_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$4 = ["data-module-id"];
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "EmailCapture",
  props: {
    moduleProps: {}
  },
  setup(__props) {
    const moduleKindButtonKindMap = {
      [ToolModuleKind.SavedSearch]: ToolActionKind.SendSaveSearch,
      [ToolModuleKind.EmailCapture]: ToolActionKind.SendSubscribe
    };
    const store = useStore();
    const props = __props;
    const emailRef = ref();
    const termsRef = ref(null);
    const emailValue = ref("");
    const propertyTerms = computed(() => {
      var _a;
      return ((_a = store == null ? void 0 : store.extraData.defaultAssets) == null ? void 0 : _a.terms) || [];
    });
    const termsArray = computed(() => props.moduleProps.terms.customTerms);
    const isTermRequired = computed(() => props.moduleProps.terms.isTermRequired);
    const isTermsInheritedFromProperty = computed(
      () => props.moduleProps.terms.isTermsInheritedFromProperty
    );
    const errorMessage = computed(() => store == null ? void 0 : store.literals.getLiteral("Please, provide a valid e-mail"));
    const placeholder = computed(() => store == null ? void 0 : store.literals.getLiteral("Your email"));
    const sending = computed(() => (store == null ? void 0 : store.handlers.buttonState) === ButtonState.Sending);
    const appearanceStyle = computed(() => useTextAppearance(props.moduleProps.appearance, store == null ? void 0 : store.device));
    function validate() {
      if (emailRef.value && termsRef.value) {
        const emailValid = emailRef.value.validate();
        if (emailValid) {
          const termsValid = termsRef.value.validate();
          if (termsValid.valid) {
            return {
              emailAddress: emailValue.value,
              terms: termsValid.terms
            };
          }
        }
      }
      return false;
    }
    onMounted(() => {
      store == null ? void 0 : store.handlers.setDataValidator(moduleKindButtonKindMap[props.moduleProps.moduleType], validate);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-emailcapture",
        "data-module-id": _ctx.moduleProps.id,
        style: normalizeStyle(appearanceStyle.value)
      }, [
        createVNode(_sfc_main$a, {
          class: "thn--tool-emailcapture__input",
          ref_key: "emailRef",
          ref: emailRef,
          type: "email",
          modelValue: emailValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => emailValue.value = $event),
          placeholder: placeholder.value,
          "error-message": errorMessage.value,
          disabled: !!sending.value,
          required: true
        }, null, 8, ["modelValue", "placeholder", "error-message", "disabled"]),
        createVNode(_sfc_main$5, {
          class: "thn--tool-emailcapture__terms",
          ref_key: "termsRef",
          ref: termsRef,
          disabled: !!sending.value,
          "custom-terms": termsArray.value,
          "property-terms": propertyTerms.value,
          "terms-inherited": isTermsInheritedFromProperty.value,
          "terms-required": isTermRequired.value,
          "appearance-style": appearanceStyle.value
        }, null, 8, ["disabled", "custom-terms", "property-terms", "terms-inherited", "terms-required", "appearance-style"])
      ], 12, _hoisted_1$4);
    };
  }
});
const EmailCapture_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$3 = ["data-module-id"];
const _hoisted_2$2 = {
  key: 0,
  class: "thn--tool-perks__bullet"
};
const _hoisted_3$1 = { class: "thn--tool-perks__label" };
const _hoisted_4$1 = ["innerHTML"];
const _hoisted_5$1 = ["onMouseover", "onMouseout"];
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "Perks",
  props: {
    moduleProps: {}
  },
  setup(__props) {
    const store = useStore();
    const props = __props;
    const tooltipRefs = ref({});
    const isTitleCase = computed(() => {
      var _a;
      const otherTextTransform = (_a = store == null ? void 0 : store.styles.fonts.other) == null ? void 0 : _a.textTransform;
      return otherTextTransform === TextTransform.Titlecase;
    });
    const appearanceStyle = computed(() => useTextAppearance(props.moduleProps.appearance, store == null ? void 0 : store.device));
    const inherited = computed(() => props.moduleProps.isPerksInheritedFromProperty);
    const perksList = computed(() => {
      var _a;
      return inherited.value ? (_a = store == null ? void 0 : store.extraData.defaultAssets) == null ? void 0 : _a.perks : props.moduleProps.perks;
    });
    function onOverIcon(target, perkId) {
      var _a;
      const perkData = (_a = perksList.value) == null ? void 0 : _a.find((perk) => perk.perkId === perkId);
      const tooltipMessage = perkData && perkData.perk.tooltipInfo && (store == null ? void 0 : store.literals.getPerkTooltipLiteral(perkData.perk.tooltipInfo));
      const {
        left,
        top,
        width
      } = target.getBoundingClientRect();
      tooltipRefs.value[perkId].show(tooltipMessage, {
        left: left + width / 2,
        top
      });
    }
    function getLocalePerkDescription(perkData) {
      if (store && perkData.description) {
        return store.literals.getPerkActiveLiteral(perkData.description, isTitleCase.value);
      }
      return perkData.name;
    }
    function onOutIcon(perkId) {
      tooltipRefs.value[perkId].hide();
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-perks",
        "data-module-id": _ctx.moduleProps.id,
        style: normalizeStyle(appearanceStyle.value)
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(perksList.value, ({ perkId, perk }) => {
          var _a, _b;
          return openBlock(), createElementBlock("div", {
            class: normalizeClass({
              "thn--tool-perks__perk": true,
              "highlights": ((_a = _ctx.moduleProps.appearance) == null ? void 0 : _a.layout) === "highlights"
            }),
            key: perkId
          }, [
            ((_b = _ctx.moduleProps.appearance) == null ? void 0 : _b.layout) === unref(PerkLayoutKind).Bullets ? (openBlock(), createElementBlock("div", _hoisted_2$2)) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_3$1, [
              createElementVNode("span", {
                class: "thn--tool-perks__label-text",
                innerHTML: getLocalePerkDescription(perk)
              }, null, 8, _hoisted_4$1),
              !!perk.tooltipInfo ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: "thn--tool-perks__icon",
                onMouseover: (ev) => onOverIcon(ev.target, perkId),
                onMouseout: () => onOutIcon(perkId)
              }, [
                createVNode(unref(NotificationInfoIcon)),
                createVNode(_sfc_main$b, {
                  class: "thn--tool-perks__tooltip",
                  ref_for: true,
                  ref: (ref2) => tooltipRefs.value[perkId] = ref2,
                  "back-color": "#ffffff",
                  color: "#000000"
                }, null, 512)
              ], 40, _hoisted_5$1)) : createCommentVNode("", true)
            ])
          ], 2);
        }), 128))
      ], 12, _hoisted_1$3);
    };
  }
});
const Perks_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$2 = ["data-module-id", "data-style", "data-size"];
const _hoisted_2$1 = { class: "thn--tool-countdown__number" };
const _hoisted_3 = { class: "thn--tool-countdown__label" };
const _hoisted_4 = ["title"];
const _hoisted_5 = { key: 1 };
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "Countdown",
  props: {
    moduleProps: {}
  },
  setup(__props) {
    const store = useStore();
    const props = __props;
    const zeroBlocks = {
      hours: "00",
      minutes: "00",
      seconds: "00"
    };
    const countdownBlocks = ref(zeroBlocks);
    const stoped = ref(true);
    const endTimestamp = ref();
    const paused = ref(false);
    const layout = inject("layout");
    const mustShowLabelAbbreviation = computed(() => {
      var _a, _b;
      return ((_a = props.moduleProps.appearance) == null ? void 0 : _a.size) === "compact" && ((_b = layout == null ? void 0 : layout.value) == null ? void 0 : _b.type) === ToolLayoutKind.StickyImage;
    });
    watchEffect(() => {
      const {
        type,
        details
      } = props.moduleProps;
      const newTimestamp = (store == null ? void 0 : store.extraData.countdownTimestamp) ? store == null ? void 0 : store.extraData.countdownTimestamp : (store == null ? void 0 : store.extraData.getCountdownTimestamp(type, details)) || Date.now();
      const {
        builderMode = false,
        countdownInitTime = Date.now()
      } = (store == null ? void 0 : store.extraData) || {};
      paused.value = builderMode && type === CountdownKind.Time;
      endTimestamp.value = paused.value ? newTimestamp - countdownInitTime : newTimestamp;
    });
    function updateCountdownBlocks() {
      if (!stoped.value) {
        const refTimestamp = Math.round((endTimestamp.value - (!paused.value ? Date.now() : 0)) / 1e3);
        if (refTimestamp > 0) {
          const mins = refTimestamp / 60;
          const hours = mins / 60;
          const days = Math.floor(hours / 24);
          const blocks = {
            days: padNumber(days),
            hours: padNumber(hours % 24),
            minutes: padNumber(mins % 60),
            seconds: padNumber(refTimestamp % 60)
          };
          if (!days) {
            delete blocks.days;
          } else {
            delete blocks.seconds;
          }
          countdownBlocks.value = blocks;
          setTimeout(updateCountdownBlocks, 200);
        } else {
          countdownBlocks.value = zeroBlocks;
        }
      }
    }
    watchEffect(updateCountdownBlocks);
    onMounted(() => {
      stoped.value = false;
    });
    onBeforeUnmount(() => {
      stoped.value = true;
    });
    return (_ctx, _cache) => {
      var _a, _b;
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-countdown",
        "data-module-id": _ctx.moduleProps.id,
        "data-style": (_a = _ctx.moduleProps.appearance) == null ? void 0 : _a.style,
        "data-size": (_b = _ctx.moduleProps.appearance) == null ? void 0 : _b.size
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(countdownBlocks.value, (value, id) => {
          var _a2, _b2, _c;
          return openBlock(), createElementBlock("div", {
            class: "thn--tool-countdown__block",
            key: id
          }, [
            createElementVNode("div", _hoisted_2$1, toDisplayString(value), 1),
            createElementVNode("div", _hoisted_3, [
              mustShowLabelAbbreviation.value ? (openBlock(), createElementBlock("abbr", {
                key: 0,
                title: (_a2 = unref(store)) == null ? void 0 : _a2.literals.getLiteral(id)
              }, toDisplayString((_b2 = unref(store)) == null ? void 0 : _b2.literals.getLiteralAbb(id)), 9, _hoisted_4)) : (openBlock(), createElementBlock("span", _hoisted_5, toDisplayString((_c = unref(store)) == null ? void 0 : _c.literals.getLiteral(id)), 1))
            ])
          ]);
        }), 128))
      ], 8, _hoisted_1$2);
    };
  }
});
const Countdown_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$1 = ["data-module-id"];
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "Form",
  props: {
    moduleProps: {}
  },
  setup(__props) {
    const store = useStore();
    const props = __props;
    const termsRef = ref(null);
    const viewerRef = ref();
    const FormViewer = defineAsyncComponent(
      () => import("@thehotelsnetwork/custom-forms/form-viewer")
    );
    const sending = computed(() => (store == null ? void 0 : store.handlers.buttonState) === ButtonState.Sending);
    const propertyTerms = computed(() => {
      var _a;
      return (_a = store == null ? void 0 : store.extraData.defaultAssets) == null ? void 0 : _a.terms;
    });
    const termsArray = computed(() => props.moduleProps.terms.customTerms);
    const isTermRequired = computed(() => props.moduleProps.terms.isTermRequired);
    const isTermsInheritedFromProperty = computed(
      () => props.moduleProps.terms.isTermsInheritedFromProperty
    );
    const formValues = ref([]);
    const appearanceStyle = computed(() => useTextAppearance(props.moduleProps.appearance, store == null ? void 0 : store.device));
    const updateValues = (formData) => {
      formValues.value = formData.values;
    };
    const formSchema = computed(() => {
      const {
        name,
        fields,
        fieldsPosition
      } = props.moduleProps;
      const labelDisplayPosition = fieldsPosition === FormFieldsPosition.Out ? 1 : 2;
      return {
        lang: store == null ? void 0 : store.language,
        data: {
          name,
          fields: fields.map((field) => {
            const {
              id,
              type,
              labels,
              hiddenName,
              optional,
              options = [],
              selection = FormSelectionKind.Single,
              defaultOption,
              popupPosition
            } = field;
            const parsedOptions = options.map((option) => ({
              value: option.id,
              label: option.labels
            }));
            const selectionType = selection === FormSelectionKind.Multiple ? "multiSelection" : "oneSelection";
            const parsedType = type === FormFieldKind.Selection ? selectionType : type;
            return {
              type: parsedType,
              default: defaultOption,
              label: labels,
              labelDisplay: hiddenName ? 0 : labelDisplayPosition,
              name: id,
              required: !optional,
              options: parsedOptions,
              popupPosition
            };
          })
        }
      };
    });
    async function validate() {
      if (viewerRef.value && termsRef.value) {
        const formValid = await viewerRef.value.formRef.validate();
        if (formValid.valid) {
          const termsValid = termsRef.value.validate();
          if (termsValid.valid) {
            return {
              formFields: toRaw(formValues.value),
              terms: termsValid.terms
            };
          }
        }
      }
      return false;
    }
    onMounted(() => {
      store == null ? void 0 : store.handlers.setDataValidator(ToolActionKind.SendForm, validate);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-form",
        style: normalizeStyle(appearanceStyle.value),
        "data-module-id": _ctx.moduleProps.id
      }, [
        formSchema.value ? (openBlock(), createBlock(unref(FormViewer), mergeProps({
          key: 0,
          class: "thn--tool-form__viewer",
          ref_key: "viewerRef",
          ref: viewerRef
        }, formSchema.value, { onChange: updateValues }), null, 16)) : createCommentVNode("", true),
        createVNode(_sfc_main$5, {
          class: "thn--tool-form__terms",
          ref_key: "termsRef",
          ref: termsRef,
          disabled: !!sending.value,
          "custom-terms": termsArray.value,
          "property-terms": propertyTerms.value,
          "terms-inherited": isTermsInheritedFromProperty.value,
          "terms-required": isTermRequired.value,
          "appearance-style": appearanceStyle.value
        }, null, 8, ["disabled", "custom-terms", "property-terms", "terms-inherited", "terms-required", "appearance-style"])
      ], 12, _hoisted_1$1);
    };
  }
});
const Form_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = ["can-animate"];
const _hoisted_2 = ["state", "data-add-module", "data-vertical-center"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Steps",
  props: {
    steps: {},
    hasExtraSteps: {},
    maxHeight: {},
    toolKind: {},
    layoutKind: {}
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "11f1fc0a": marginTopArHeb.value,
      "b6e83452": innerHeigth.value
    }));
    const moduleKindToComponentMap = {
      [ToolModuleKind.Heading]: _sfc_main$g,
      [ToolModuleKind.Paragraph]: _sfc_main$g,
      [ToolModuleKind.SavedSearch]: _sfc_main$4,
      [ToolModuleKind.EmailCapture]: _sfc_main$4,
      [ToolModuleKind.Button]: _sfc_main$h,
      [ToolModuleKind.Perks]: _sfc_main$3,
      [ToolModuleKind.Countdown]: _sfc_main$2,
      [ToolModuleKind.Form]: _sfc_main$1
    };
    const store = useStore();
    const props = __props;
    const rootDom = ref();
    const stepActiveDom = computed(() => {
      var _a;
      return (_a = rootDom.value) == null ? void 0 : _a.querySelector(`.thn--tool-steps__step--${store == null ? void 0 : store.handlers.stepActive}`);
    });
    const stepIds = computed(() => Object.keys(props.steps));
    const { height: stepHeight } = useElementSize(stepActiveDom);
    const innerHeigth = computed(() => props.toolKind === ToolKind.Inliner ? "0" : "100%");
    const rootStyle = computed(() => {
      let padding = parseInt((store == null ? void 0 : store.styles.getCssVariableValue("--step-padding")) || "10", 10);
      padding = props.layoutKind === ToolLayoutKind.LowerNotification ? padding * 2 + 5 : padding;
      let stepH = stepHeight.value + 2 * padding;
      if (props.maxHeight) {
        stepH = Math.min(props.maxHeight, stepH);
      }
      return {
        height: props.layoutKind === ToolLayoutKind.SquareImage && props.toolKind !== ToolKind.Inliner ? "100%" : appendPx(stepH),
        overflowY: (store == null ? void 0 : store.handlers.isFirstStep) ? "auto" : "hidden"
      };
    });
    const marginTopArHeb = computed(() => (store == null ? void 0 : store.rtl) ? "10px" : "0");
    function getModuleComponent(moduleKind) {
      return moduleKindToComponentMap[moduleKind] || "div";
    }
    function getStepState(stepId) {
      switch (true) {
        case (store == null ? void 0 : store.handlers.stepActive) === stepId:
          return StepState.Active;
        case (store == null ? void 0 : store.handlers.stepPrevious) === stepId:
          return StepState.Previous;
        default:
          return StepState.Next;
      }
    }
    onMounted(() => {
      stepsWrapper.value = rootDom.value;
    });
    return (_ctx, _cache) => {
      var _a;
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-steps",
        ref_key: "rootDom",
        ref: rootDom,
        style: normalizeStyle(rootStyle.value),
        "can-animate": !((_a = unref(store)) == null ? void 0 : _a.handlers.isFirstStep),
        "data-testid": "steps"
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(stepIds.value, (stepId) => {
          var _a2;
          return openBlock(), createElementBlock("div", {
            class: normalizeClass(`thn--tool-steps__step thn--tool-steps__step--${stepId}`),
            state: getStepState(stepId),
            key: stepId,
            "data-add-module": stepId === unref(DefaultStep).Main && stepId === ((_a2 = unref(store)) == null ? void 0 : _a2.handlers.stepActive),
            "data-vertical-center": _ctx.layoutKind === unref(ToolLayoutKind).SquareImage
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.steps[stepId], (moduleProps, moduleIndex) => {
              return openBlock(), createBlock(resolveDynamicComponent(getModuleComponent(moduleProps.moduleType)), mergeProps({
                class: "thn--tool-steps__step-component",
                key: moduleIndex,
                "has-extra-steps": _ctx.hasExtraSteps
              }, {
                moduleProps
              }), null, 16, ["has-extra-steps"]);
            }), 128))
          ], 10, _hoisted_2);
        }), 128))
      ], 12, _hoisted_1);
    };
  }
});
const Steps_vue_vue_type_style_index_0_lang = "";
export {
  _sfc_main$c as Back,
  _sfc_main$9 as Checkbox,
  _sfc_main$k as Exit,
  _sfc_main$j as Inliner,
  _sfc_main$a as Input,
  _sfc_main$8 as Modal,
  _sfc_main$d as Note,
  _sfc_main$7 as Overlay,
  _sfc_main$l as Popup,
  SlideDown,
  StepState,
  _sfc_main as Steps,
  _sfc_main$5 as Terms,
  _sfc_main$b as Tooltip,
  _sfc_main$i as XClose,
  _export_sfc as _,
  toggleModal as a,
  appendEm,
  appendPercent,
  appendPx,
  _sfc_main$e as b,
  _sfc_main$h as c,
  calcMarginByDevice,
  calcPlacementByDevice,
  calcWidthByDevice,
  camelToSnakeCase,
  colorHelper,
  debounce as d,
  defaultBackgroundStyles,
  defaultButtonStyles,
  defaultColorStyles,
  defaultFontsStyles,
  defaultInlinerBackgroundStyles,
  defaultOverlayStyles,
  defaultStyles,
  getButtonActionType,
  getCornerRadius,
  getPaddingLiteral,
  getTransitionName,
  hexToRgba,
  isObj,
  modalOpen as m,
  noteDefaultColorsStyles,
  padNumber,
  parseToolData,
  termsText as t,
  toKebabCase,
  toPascalCase,
  toTitleCase,
  useStore as u,
  useDefaultStyles
};
//# sourceMappingURL=p-components.mjs.map
